// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M0.5 6h14%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23ffffff%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: MediumFont, Manrope, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

.tooltip-arrow,.tooltip-arrow:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

.tooltip-arrow {
  visibility: hidden;
}

.tooltip-arrow:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before {
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before {
  visibility: hidden;
}

[data-popper-arrow],[data-popper-arrow]:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow] {
  visibility: hidden;
}

[data-popper-arrow]:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow] {
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow] {
  left: -5px;
}

[role="tooltip"].invisible > [data-popper-arrow]:before {
  visibility: hidden;
}

[role="tooltip"].invisible > [data-popper-arrow]:after {
  visibility: hidden;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}

input::placeholder,textarea::placeholder {
  color: #6B7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
}

select:not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  print-color-adjust: exact;
}

:is([dir=rtl]) select:not([size]) {
  background-position: left 0.75rem center;
  padding-right: 0.75rem;
  padding-left: 0;
}

[multiple] {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #1C64F2;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  print-color-adjust: exact;
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button {
  color: white;
  background: #1F2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-inline-start: -1rem;
  margin-inline-end: 1rem;
}

input[type=file]::file-selector-button:hover {
  background: #374151;
}

:is([dir=rtl]) input[type=file]::file-selector-button {
  padding-right: 2rem;
  padding-left: 1rem;
}

.dark input[type=file]::file-selector-button {
  color: white;
  background: #4B5563;
}

.dark input[type=file]::file-selector-button:hover {
  background: #6B7280;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb {
  background: #6B7280;
}

input[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-moz-range-thumb {
  background: #6B7280;
}

input[type="range"]::-moz-range-progress {
  background: #3F83F8;
}

input[type="range"]::-ms-fill-lower {
  background: #3F83F8;
}

html[dir='rtl'] body {
  direction: rtl;
  text-align: right;
  font-size: 1.5rem;
}

html[dir='ltr'] body {
  direction: ltr;
  text-align: left;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 320px) {

  .\\!container {
    max-width: 320px !important;
  }

  .container {
    max-width: 320px;
  }
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1214px) {

  .\\!container {
    max-width: 1214px !important;
  }

  .container {
    max-width: 1214px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 1600px) {

  .\\!container {
    max-width: 1600px !important;
  }

  .container {
    max-width: 1600px;
  }
}
@media (min-width: 1920px) {

  .\\!container {
    max-width: 1920px !important;
  }

  .container {
    max-width: 1920px;
  }
}
@media (min-width: 2560px) {

  .\\!container {
    max-width: 2560px !important;
  }

  .container {
    max-width: 2560px;
  }
}
.map-control-btn {
  display: flex;
  height: 2.5rem;
  width: 2.5rem;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(215 223 234 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 8px -2px #2463eb1f;
  --tw-shadow-colored: 0 2px 8px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.map-control-btn:hover {
  border-color: #2463eb4d;
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 254 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 4px 12px -2px #2463eb2e;
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.date-chip {
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(215 223 234 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.date-chip:hover {
  border-color: #2463eb66;
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 254 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 2px 8px -2px #2463eb26;
  --tw-shadow-colored: 0 2px 8px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 768px) {

  .date-chip {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
}
.date-chip-active {
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(36 99 235 / var(--tw-border-opacity, 1));
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #2463eb1a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(36 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #2463eb0d var(--tw-gradient-to-position);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(36 99 235 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 2px 12px -2px #2463eb40;
  --tw-shadow-colored: 0 2px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.page-title {
  margin-bottom: 0px;
  display: block;
  white-space: nowrap;
  font-weight: 600;
  text-transform: uppercase;
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
    margin-left: 0 !important;
    margin-top: 0 !important;
}
.page-content-root {
    border-left: 0 !important;
    outline-left: 0 !important;
  }
.page-content-root::before,
  .page-content-root::after,
  .page-content-root>*::before,
  .page-content-root>*::after {
    border-left: 0 !important;
    box-shadow: none !important;
    background-image: none !important;
  }
.page-content-root>* {
    border-left: 0 !important;
  }
.page-stack {
  display: flex;
  flex-direction: column;
  gap: 1rem;
    border-left: 0 !important;
    padding-left: 0 !important;
    margin-left: 0 !important;
}
.pager-nav {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
}
.pager-icon-btn {
  display: inline-flex;
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.pager-icon-btn:not(:disabled):hover {
  --tw-border-opacity: 1;
  border-color: rgb(225 239 254 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(35 109 180 / var(--tw-text-opacity, 1));
}
.pager-icon-btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
.search-input {
  height: 42px;
  width: 100%;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.search-input:focus {
  --tw-border-opacity: 1;
  border-color: rgb(118 169 250 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!visible {
  visibility: visible !important;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.\\!relative {
  position: relative !important;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.inset-y-1 {
  top: 0.25rem;
  bottom: 0.25rem;
}
.\\!left-\\[2\\%\\] {
  left: 2% !important;
}
.\\!right-\\[2\\%\\] {
  right: 2% !important;
}
.\\!top-\\[7\\%\\] {
  top: 7% !important;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-\\[6px\\] {
  bottom: -6px;
}
.-left-1 {
  left: -0.25rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-2 {
  left: -0.5rem;
}
.-left-3 {
  left: -0.75rem;
}
.-left-6 {
  left: -1.5rem;
}
.-left-\\[6px\\] {
  left: -6px;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.-right-2 {
  right: -0.5rem;
}
.-right-6 {
  right: -1.5rem;
}
.-right-\\[6px\\] {
  right: -6px;
}
.-top-1 {
  top: -0.25rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-6 {
  top: -1.5rem;
}
.-top-\\[6px\\] {
  top: -6px;
}
.-top-\\[7px\\] {
  top: -7px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-20 {
  bottom: 5rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-\\[-5px\\] {
  bottom: -5px;
}
.bottom-full {
  bottom: 100%;
}
.end-0 {
  inset-inline-end: 0px;
}
.end-3 {
  inset-inline-end: 0.75rem;
}
.end-4 {
  inset-inline-end: 1rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[-5px\\] {
  left: -5px;
}
.left-\\[11px\\] {
  left: 11px;
}
.left-\\[15px\\] {
  left: 15px;
}
.left-\\[2px\\] {
  left: 2px;
}
.left-\\[3px\\] {
  left: 3px;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-1\\.5 {
  right: 0.375rem;
}
.right-10 {
  right: 2.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-3\\.5 {
  right: 0.875rem;
}
.right-4 {
  right: 1rem;
}
.right-6 {
  right: 1.5rem;
}
.right-\\[-5px\\] {
  right: -5px;
}
.right-\\[15px\\] {
  right: 15px;
}
.right-\\[2px\\] {
  right: 2px;
}
.right-\\[3px\\] {
  right: 3px;
}
.start-0 {
  inset-inline-start: 0px;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-3\\.5 {
  top: 0.875rem;
}
.top-32 {
  top: 8rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[-5px\\] {
  top: -5px;
}
.top-\\[11px\\] {
  top: 11px;
}
.top-\\[2px\\] {
  top: 2px;
}
.top-\\[3px\\] {
  top: 3px;
}
.top-full {
  top: 100%;
}
.isolate {
  isolation: isolate;
}
.\\!z-\\[100000\\] {
  z-index: 100000 !important;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100000\\] {
  z-index: 100000;
}
.z-\\[10000\\] {
  z-index: 10000;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[1004\\] {
  z-index: 1004;
}
.z-\\[1005\\] {
  z-index: 1005;
}
.z-\\[10060\\] {
  z-index: 10060;
}
.z-\\[1006\\] {
  z-index: 1006;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[11000\\] {
  z-index: 11000;
}
.z-\\[1100\\] {
  z-index: 1100;
}
.z-\\[110\\] {
  z-index: 110;
}
.z-\\[1200\\] {
  z-index: 1200;
}
.z-\\[120\\] {
  z-index: 120;
}
.z-\\[1250\\] {
  z-index: 1250;
}
.z-\\[1300\\] {
  z-index: 1300;
}
.z-\\[1400\\] {
  z-index: 1400;
}
.z-\\[1500\\] {
  z-index: 1500;
}
.z-\\[150\\] {
  z-index: 150;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[45\\] {
  z-index: 45;
}
.z-\\[46\\] {
  z-index: 46;
}
.z-\\[4\\] {
  z-index: 4;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[70\\] {
  z-index: 70;
}
.z-\\[80\\] {
  z-index: 80;
}
.z-\\[90\\] {
  z-index: 90;
}
.z-\\[9999999\\] {
  z-index: 9999999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-auto {
  z-index: auto;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-1 {
  grid-column: span 1 / span 1;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.float-right {
  float: right;
}
.-m-1\\.5 {
  margin: -0.375rem;
}
.m-0 {
  margin: 0px;
}
.m-2 {
  margin: 0.5rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-4 {
  margin: 1rem;
}
.m-5 {
  margin: 1.25rem;
}
.\\!my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.-mx-1\\.5 {
  margin-left: -0.375rem;
  margin-right: -0.375rem;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}
.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-0\\.5 {
  margin-left: 0.125rem;
  margin-right: 0.125rem;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0\\.5 {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-1\\.5 {
  margin-top: 0.375rem;
  margin-bottom: 0.375rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!ml-2 {
  margin-left: 0.5rem !important;
}
.-mb-5 {
  margin-bottom: -1.25rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1\\.5 {
  margin-left: -0.375rem;
}
.-mr-0\\.5 {
  margin-right: -0.125rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mr-1\\.5 {
  margin-right: -0.375rem;
}
.-ms-4 {
  margin-inline-start: -1rem;
}
.-mt-1 {
  margin-top: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-20 {
  margin-bottom: 5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[16px\\] {
  margin-bottom: 16px;
}
.mb-\\[24px\\] {
  margin-bottom: 24px;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-11 {
  margin-left: 2.75rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-48 {
  margin-left: 12rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-0 {
  margin-right: 0px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-auto {
  margin-right: auto;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-1\\.5 {
  margin-inline-start: 0.375rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-40 {
  margin-top: 10rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[14px\\] {
  margin-top: 14px;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.mt-\\[2px\\] {
  margin-top: 2px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.\\!inline-flex {
  display: inline-flex !important;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.size-4 {
  width: 1rem;
  height: 1rem;
}
.\\!h-10 {
  height: 2.5rem !important;
}
.\\!h-7 {
  height: 1.75rem !important;
}
.\\!h-8 {
  height: 2rem !important;
}
.\\!h-9 {
  height: 2.25rem !important;
}
.\\!h-\\[50px\\] {
  height: 50px !important;
}
.\\!h-auto {
  height: auto !important;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-3\\/4 {
  height: 75%;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-40 {
  height: 10rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[100dvh\\] {
  height: 100dvh;
}
.h-\\[13px\\] {
  height: 13px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[222px\\] {
  height: 222px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[250px\\] {
  height: 250px;
}
.h-\\[25vh\\] {
  height: 25vh;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[350px\\] {
  height: 350px;
}
.h-\\[360px\\] {
  height: 360px;
}
.h-\\[36px\\] {
  height: 36px;
}
.h-\\[38px\\] {
  height: 38px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[42dvh\\] {
  height: 42dvh;
}
.h-\\[42px\\] {
  height: 42px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-\\[500px\\] {
  height: 500px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[55dvh\\] {
  height: 55dvh;
}
.h-\\[70vh\\] {
  height: 70vh;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-\\[7px\\] {
  height: 7px;
}
.h-\\[800px\\] {
  height: 800px;
}
.h-\\[88vh\\] {
  height: 88vh;
}
.h-\\[calc\\(100\\%-1\\.5rem\\)\\] {
  height: calc(100% - 1.5rem);
}
.h-\\[calc\\(100vh-2rem\\)\\] {
  height: calc(100vh - 2rem);
}
.h-auto {
  height: auto;
}
.h-dvh {
  height: 100dvh;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.\\!max-h-10 {
  max-height: 2.5rem !important;
}
.\\!max-h-none {
  max-height: none !important;
}
.max-h-0 {
  max-height: 0px;
}
.max-h-10 {
  max-height: 2.5rem;
}
.max-h-28 {
  max-height: 7rem;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-44 {
  max-height: 11rem;
}
.max-h-48 {
  max-height: 12rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-60 {
  max-height: 15rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-\\[100dvh\\] {
  max-height: 100dvh;
}
.max-h-\\[114px\\] {
  max-height: 114px;
}
.max-h-\\[120px\\] {
  max-height: 120px;
}
.max-h-\\[150px\\] {
  max-height: 150px;
}
.max-h-\\[190px\\] {
  max-height: 190px;
}
.max-h-\\[20000px\\] {
  max-height: 20000px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[250px\\] {
  max-height: 250px;
}
.max-h-\\[25vh\\] {
  max-height: 25vh;
}
.max-h-\\[280px\\] {
  max-height: 280px;
}
.max-h-\\[300px\\] {
  max-height: 300px;
}
.max-h-\\[400px\\] {
  max-height: 400px;
}
.max-h-\\[420px\\] {
  max-height: 420px;
}
.max-h-\\[42vh\\] {
  max-height: 42vh;
}
.max-h-\\[450px\\] {
  max-height: 450px;
}
.max-h-\\[500px\\] {
  max-height: 500px;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[560px\\] {
  max-height: 560px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.max-h-\\[80vh\\] {
  max-height: 80vh;
}
.max-h-\\[850px\\] {
  max-height: 850px;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[88vh\\] {
  max-height: 88vh;
}
.max-h-\\[90dvh\\] {
  max-height: 90dvh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.max-h-\\[93vh\\] {
  max-height: 93vh;
}
.max-h-\\[calc\\(100dvh-1rem\\)\\] {
  max-height: calc(100dvh - 1rem);
}
.max-h-\\[calc\\(100dvh-2rem\\)\\] {
  max-height: calc(100dvh - 2rem);
}
.max-h-\\[calc\\(100vh-2rem\\)\\] {
  max-height: calc(100vh - 2rem);
}
.max-h-full {
  max-height: 100%;
}
.max-h-none {
  max-height: none;
}
.max-h-screen {
  max-height: 100vh;
}
.\\!min-h-0 {
  min-height: 0px !important;
}
.\\!min-h-\\[32px\\] {
  min-height: 32px !important;
}
.\\!min-h-\\[36px\\] {
  min-height: 36px !important;
}
.\\!min-h-\\[38px\\] {
  min-height: 38px !important;
}
.\\!min-h-\\[40px\\] {
  min-height: 40px !important;
}
.\\!min-h-\\[50px\\] {
  min-height: 50px !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-16 {
  min-height: 4rem;
}
.min-h-7 {
  min-height: 1.75rem;
}
.min-h-\\[100dvh\\] {
  min-height: 100dvh;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[140px\\] {
  min-height: 140px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[170px\\] {
  min-height: 170px;
}
.min-h-\\[18px\\] {
  min-height: 18px;
}
.min-h-\\[200px\\] {
  min-height: 200px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[22rem\\] {
  min-height: 22rem;
}
.min-h-\\[230px\\] {
  min-height: 230px;
}
.min-h-\\[240px\\] {
  min-height: 240px;
}
.min-h-\\[24rem\\] {
  min-height: 24rem;
}
.min-h-\\[256px\\] {
  min-height: 256px;
}
.min-h-\\[280px\\] {
  min-height: 280px;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-\\[30rem\\] {
  min-height: 30rem;
}
.min-h-\\[320px\\] {
  min-height: 320px;
}
.min-h-\\[32px\\] {
  min-height: 32px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[360px\\] {
  min-height: 360px;
}
.min-h-\\[36px\\] {
  min-height: 36px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[420px\\] {
  min-height: 420px;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[44px\\] {
  min-height: 44px;
}
.min-h-\\[44vh\\] {
  min-height: 44vh;
}
.min-h-\\[46px\\] {
  min-height: 46px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-\\[50px\\] {
  min-height: 50px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-\\[6rem\\] {
  min-height: 6rem;
}
.min-h-\\[80px\\] {
  min-height: 80px;
}
.min-h-\\[90px\\] {
  min-height: 90px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.\\!w-10 {
  width: 2.5rem !important;
}
.\\!w-7 {
  width: 1.75rem !important;
}
.\\!w-8 {
  width: 2rem !important;
}
.\\!w-9 {
  width: 2.25rem !important;
}
.\\!w-auto {
  width: auto !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-1\\/6 {
  width: 16.666667%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-2\\/3 {
  width: 66.666667%;
}
.w-2\\/4 {
  width: 50%;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-52 {
  width: 13rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[108px\\] {
  width: 108px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[210px\\] {
  width: 210px;
}
.w-\\[22\\%\\] {
  width: 22%;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[30\\%\\] {
  width: 30%;
}
.w-\\[300px\\] {
  width: 300px;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[330px\\] {
  width: 330px;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[380px\\] {
  width: 380px;
}
.w-\\[38px\\] {
  width: 38px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[42\\%\\] {
  width: 42%;
}
.w-\\[42px\\] {
  width: 42px;
}
.w-\\[44px\\] {
  width: 44px;
}
.w-\\[48\\%\\] {
  width: 48%;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[550px\\] {
  width: 550px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[64px\\] {
  width: 64px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[7px\\] {
  width: 7px;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-\\[88vw\\] {
  width: 88vw;
}
.w-\\[90px\\] {
  width: 90px;
}
.w-\\[92vw\\] {
  width: 92vw;
}
.w-\\[94vw\\] {
  width: 94vw;
}
.w-\\[96px\\] {
  width: 96px;
}
.w-\\[96vw\\] {
  width: 96vw;
}
.w-\\[98px\\] {
  width: 98px;
}
.w-\\[calc\\(100vw-2rem\\)\\] {
  width: calc(100vw - 2rem);
}
.w-\\[calc\\(50\\%-4px\\)\\] {
  width: calc(50% - 4px);
}
.w-\\[min\\(15rem\\2c calc\\(100vw-2rem\\)\\)\\] {
  width: min(15rem, calc(100vw - 2rem));
}
.w-\\[min\\(18rem\\2c calc\\(100vw-2rem\\)\\)\\] {
  width: min(18rem, calc(100vw - 2rem));
}
.w-\\[min\\(720px\\2c 92vw\\)\\] {
  width: min(720px, 92vw);
}
.w-\\[min\\(92vw\\2c 26rem\\)\\] {
  width: min(92vw, 26rem);
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-px {
  width: 1px;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-4 {
  min-width: 1rem;
}
.min-w-7 {
  min-width: 1.75rem;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[104px\\] {
  min-width: 104px;
}
.min-w-\\[108px\\] {
  min-width: 108px;
}
.min-w-\\[1100px\\] {
  min-width: 1100px;
}
.min-w-\\[1140px\\] {
  min-width: 1140px;
}
.min-w-\\[1150px\\] {
  min-width: 1150px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[130px\\] {
  min-width: 130px;
}
.min-w-\\[132px\\] {
  min-width: 132px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[14rem\\] {
  min-width: 14rem;
}
.min-w-\\[150px\\] {
  min-width: 150px;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[170px\\] {
  min-width: 170px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[190px\\] {
  min-width: 190px;
}
.min-w-\\[19px\\] {
  min-width: 19px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.min-w-\\[220px\\] {
  min-width: 220px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[26px\\] {
  min-width: 26px;
}
.min-w-\\[280px\\] {
  min-width: 280px;
}
.min-w-\\[30px\\] {
  min-width: 30px;
}
.min-w-\\[32px\\] {
  min-width: 32px;
}
.min-w-\\[34px\\] {
  min-width: 34px;
}
.min-w-\\[38px\\] {
  min-width: 38px;
}
.min-w-\\[40px\\] {
  min-width: 40px;
}
.min-w-\\[44px\\] {
  min-width: 44px;
}
.min-w-\\[500px\\] {
  min-width: 500px;
}
.min-w-\\[60px\\] {
  min-width: 60px;
}
.min-w-\\[620px\\] {
  min-width: 620px;
}
.min-w-\\[640px\\] {
  min-width: 640px;
}
.min-w-\\[680px\\] {
  min-width: 680px;
}
.min-w-\\[700px\\] {
  min-width: 700px;
}
.min-w-\\[72px\\] {
  min-width: 72px;
}
.min-w-\\[740px\\] {
  min-width: 740px;
}
.min-w-\\[760px\\] {
  min-width: 760px;
}
.min-w-\\[88px\\] {
  min-width: 88px;
}
.min-w-\\[90px\\] {
  min-width: 90px;
}
.min-w-\\[920px\\] {
  min-width: 920px;
}
.min-w-\\[960px\\] {
  min-width: 960px;
}
.min-w-\\[96px\\] {
  min-width: 96px;
}
.min-w-\\[980px\\] {
  min-width: 980px;
}
.min-w-\\[9rem\\] {
  min-width: 9rem;
}
.min-w-\\[min\\(320px\\2c 85vw\\)\\] {
  min-width: min(320px, 85vw);
}
.min-w-full {
  min-width: 100%;
}
.min-w-max {
  min-width: max-content;
}
.\\!max-w-\\[312px\\] {
  max-width: 312px !important;
}
.\\!max-w-none {
  max-width: none !important;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-60 {
  max-width: 15rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100px\\] {
  max-width: 100px;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[108px\\] {
  max-width: 108px;
}
.max-w-\\[10rem\\] {
  max-width: 10rem;
}
.max-w-\\[110px\\] {
  max-width: 110px;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[12rem\\] {
  max-width: 12rem;
}
.max-w-\\[130px\\] {
  max-width: 130px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[14rem\\] {
  max-width: 14rem;
}
.max-w-\\[150px\\] {
  max-width: 150px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[180px\\] {
  max-width: 180px;
}
.max-w-\\[190px\\] {
  max-width: 190px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[260px\\] {
  max-width: 260px;
}
.max-w-\\[26rem\\] {
  max-width: 26rem;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[320px\\] {
  max-width: 320px;
}
.max-w-\\[340px\\] {
  max-width: 340px;
}
.max-w-\\[360px\\] {
  max-width: 360px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[44px\\] {
  max-width: 44px;
}
.max-w-\\[450px\\] {
  max-width: 450px;
}
.max-w-\\[480px\\] {
  max-width: 480px;
}
.max-w-\\[520px\\] {
  max-width: 520px;
}
.max-w-\\[560px\\] {
  max-width: 560px;
}
.max-w-\\[60px\\] {
  max-width: 60px;
}
.max-w-\\[672px\\] {
  max-width: 672px;
}
.max-w-\\[70\\%\\] {
  max-width: 70%;
}
.max-w-\\[720px\\] {
  max-width: 720px;
}
.max-w-\\[760px\\] {
  max-width: 760px;
}
.max-w-\\[8\\.5rem\\] {
  max-width: 8.5rem;
}
.max-w-\\[85vw\\] {
  max-width: 85vw;
}
.max-w-\\[88\\%\\] {
  max-width: 88%;
}
.max-w-\\[882px\\] {
  max-width: 882px;
}
.max-w-\\[960px\\] {
  max-width: 960px;
}
.max-w-\\[96px\\] {
  max-width: 96px;
}
.max-w-\\[calc\\(100\\%_-_24px\\)\\] {
  max-width: calc(100% - 24px);
}
.max-w-\\[calc\\(100vw-16px\\)\\] {
  max-width: calc(100vw - 16px);
}
.max-w-\\[calc\\(100vw-20px\\)\\] {
  max-width: calc(100vw - 20px);
}
.max-w-\\[calc\\(100vw-2rem\\)\\] {
  max-width: calc(100vw - 2rem);
}
.max-w-\\[min\\(12rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(12rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(15rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(15rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(20rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(20rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(22rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(22rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(24rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(24rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(30rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(30rem, calc(100vw - 1.5rem));
}
.max-w-\\[min\\(8\\.5rem\\2c calc\\(100vw-1\\.5rem\\)\\)\\] {
  max-width: min(8.5rem, calc(100vw - 1.5rem));
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-none {
  max-width: none;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[1_1_120px\\] {
  flex: 1 1 120px;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.\\!shrink-0 {
  flex-shrink: 0 !important;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.grow {
  flex-grow: 1;
}
.basis-52 {
  flex-basis: 13rem;
}
.basis-auto {
  flex-basis: auto;
}
.basis-full {
  flex-basis: 100%;
}
.table-auto {
  table-layout: auto;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.border-separate {
  border-collapse: separate;
}
.border-spacing-0 {
  --tw-border-spacing-x: 0px;
  --tw-border-spacing-y: 0px;
  border-spacing: var(--tw-border-spacing-x) var(--tw-border-spacing-y);
}
.origin-\\[0\\] {
  transform-origin: 0;
}
.origin-bottom-left {
  transform-origin: bottom left;
}
.origin-bottom-right {
  transform-origin: bottom right;
}
.origin-top-left {
  transform-origin: top left;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-4 {
  --tw-translate-x: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-5 {
  --tw-translate-x: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-6 {
  --tw-translate-x: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[13px\\] {
  --tw-translate-x: -13px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1 {
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5 {
  --tw-translate-x: 0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1 {
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4 {
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5 {
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6 {
  --tw-translate-x: 1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[13px\\] {
  --tw-translate-x: 13px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce {

  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce {
  animation: bounce 1s infinite;
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-col-resize {
  cursor: col-resize;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-help {
  cursor: help;
}
.cursor-none {
  cursor: none;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.touch-manipulation {
  touch-action: manipulation;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-mt-14 {
  scroll-margin-top: 3.5rem;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-flow-row-dense {
  grid-auto-flow: row dense;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[1fr_auto_1fr\\] {
  grid-template-columns: 1fr auto 1fr;
}
.grid-cols-\\[20px_minmax\\(0\\2c 1fr\\)_14px\\] {
  grid-template-columns: 20px minmax(0,1fr) 14px;
}
.grid-cols-\\[264px_minmax\\(520px\\2c 1fr\\)\\] {
  grid-template-columns: 264px minmax(520px,1fr);
}
.grid-cols-\\[264px_minmax\\(520px\\2c 1fr\\)_344px\\] {
  grid-template-columns: 264px minmax(520px,1fr) 344px;
}
.grid-cols-\\[40px_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 40px minmax(0,1fr);
}
.grid-cols-\\[auto_1fr_auto\\] {
  grid-template-columns: auto 1fr auto;
}
.grid-cols-\\[auto_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: auto minmax(0,1fr);
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-items-center {
  place-items: center;
}
.content-center {
  align-content: center;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.\\!justify-center {
  justify-content: center !important;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.\\!gap-1\\.5 {
  gap: 0.375rem !important;
}
.\\!gap-2 {
  gap: 0.5rem !important;
}
.\\!gap-\\[7px\\] {
  gap: 7px !important;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-14 {
  gap: 3.5rem;
}
.gap-16 {
  gap: 4rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-9 {
  gap: 2.25rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[16px\\] {
  gap: 16px;
}
.gap-\\[3px\\] {
  gap: 3px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.gap-\\[9px\\] {
  gap: 9px;
}
.gap-x-0 {
  column-gap: 0px;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-6 {
  column-gap: 1.5rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-10 {
  row-gap: 2.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.gap-y-5 {
  row-gap: 1.25rem;
}
.-space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1rem * var(--tw-space-x-reverse));
  margin-left: calc(-1rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.625rem * var(--tw-space-x-reverse));
  margin-left: calc(0.625rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.divide-inherit > :not([hidden]) ~ :not([hidden]) {
  border-color: inherit;
}
.divide-slate-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.self-end {
  align-self: flex-end;
}
.self-center {
  align-self: center;
}
.justify-self-center {
  justify-self: center;
}
.overflow-auto {
  overflow: auto;
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.\\!overflow-x-hidden {
  overflow-x: hidden !important;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.\\!overflow-y-visible {
  overflow-y: visible !important;
}
.overflow-y-visible {
  overflow-y: visible;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.\\!scroll-auto {
  scroll-behavior: auto !important;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.\\!whitespace-nowrap {
  white-space: nowrap !important;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-\\[10px\\] {
  border-radius: 10px !important;
}
.\\!rounded-\\[16px\\] {
  border-radius: 16px !important;
}
.\\!rounded-\\[8px\\] {
  border-radius: 8px !important;
}
.\\!rounded-\\[9px\\] {
  border-radius: 9px !important;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.\\!rounded-md {
  border-radius: 0.375rem !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[18px\\] {
  border-radius: 18px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[31px\\] {
  border-radius: 31px;
}
.rounded-\\[3px\\] {
  border-radius: 3px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9px\\] {
  border-radius: 9px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-\\[20px\\] {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-s-lg {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-bl-none {
  border-bottom-left-radius: 0px;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-br-none {
  border-bottom-right-radius: 0px;
}
.\\!border {
  border-width: 1px !important;
}
.\\!border-0 {
  border-width: 0px !important;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-4 {
  border-bottom-width: 4px;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-r {
  border-right-width: 1px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-s {
  border-inline-start-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#236DB4\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#818cf8\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-emerald-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2) !important;
}
.\\!border-gray-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-red-100 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(253 232 232 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-red-500\\/20 {
  border-color: rgb(240 82 82 / 0.2) !important;
}
.\\!border-slate-200 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-slate-300 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-slate-600 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-white {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#1A1A1A\\] {
  --tw-border-opacity: 1;
  border-color: rgb(26 26 26 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1d5a96\\] {
  --tw-border-opacity: 1;
  border-color: rgb(29 90 150 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1e3a53\\] {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 83 / var(--tw-border-opacity, 1));
}
.border-\\[\\#236DB4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}
.border-\\[\\#236DB4\\]\\/10 {
  border-color: rgb(35 109 180 / 0.1);
}
.border-\\[\\#236DB4\\]\\/20 {
  border-color: rgb(35 109 180 / 0.2);
}
.border-\\[\\#236DB4\\]\\/25 {
  border-color: rgb(35 109 180 / 0.25);
}
.border-\\[\\#236DB4\\]\\/30 {
  border-color: rgb(35 109 180 / 0.3);
}
.border-\\[\\#236DB4\\]\\/40 {
  border-color: rgb(35 109 180 / 0.4);
}
.border-\\[\\#236DB4\\]\\/50 {
  border-color: rgb(35 109 180 / 0.5);
}
.border-\\[\\#29a36a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(41 163 106 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2a2d33\\] {
  --tw-border-opacity: 1;
  border-color: rgb(42 45 51 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2b2b2b\\] {
  --tw-border-opacity: 1;
  border-color: rgb(43 43 43 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3F63EA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(63 99 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3F6FF5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(63 111 245 / var(--tw-border-opacity, 1));
}
.border-\\[\\#45B369\\] {
  --tw-border-opacity: 1;
  border-color: rgb(69 179 105 / var(--tw-border-opacity, 1));
}
.border-\\[\\#475569\\] {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-\\[\\#818cf8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-\\[\\#93C5FD\\] {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BEDAF0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(190 218 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#BFD5EA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(191 213 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#CFE3FB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(207 227 251 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D1D5DB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D3E7FB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(211 231 251 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D6E7F6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 231 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D7E7F6\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 231 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9E1EC\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 225 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#D9E6F5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(217 230 245 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E4E8EF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(228 232 239 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E5E7EB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E6EAF2\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 234 242 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E9E9E9\\] {
  --tw-border-opacity: 1;
  border-color: rgb(233 233 233 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FECACA\\] {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cbd5e1\\] {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d5e5f7\\] {
  --tw-border-opacity: 1;
  border-color: rgb(213 229 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d6efe3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(214 239 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d7dfea\\] {
  --tw-border-opacity: 1;
  border-color: rgb(215 223 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbe7f4\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 231 244 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e0e7ff\\] {
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e2e8f0\\] {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e6defa\\] {
  --tw-border-opacity: 1;
  border-color: rgb(230 222 250 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-200\\/90 {
  border-color: rgb(253 230 138 / 0.9);
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity, 1));
}
.border-amber-500\\/30 {
  border-color: rgb(245 158 11 / 0.3);
}
.border-amber-900\\/30 {
  border-color: rgb(120 53 15 / 0.3);
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-100 {
  --tw-border-opacity: 1;
  border-color: rgb(225 239 254 / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(195 221 253 / var(--tw-border-opacity, 1));
}
.border-blue-300 {
  --tw-border-opacity: 1;
  border-color: rgb(164 202 254 / var(--tw-border-opacity, 1));
}
.border-blue-400 {
  --tw-border-opacity: 1;
  border-color: rgb(118 169 250 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}
.border-blue-500\\/30 {
  border-color: rgb(63 131 248 / 0.3);
}
.border-blue-600 {
  --tw-border-opacity: 1;
  border-color: rgb(28 100 242 / var(--tw-border-opacity, 1));
}
.border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(35 56 118 / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(103 232 249 / var(--tw-border-opacity, 1));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}
.border-cyan-700 {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity, 1));
}
.border-emerald-100 {
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-400 {
  --tw-border-opacity: 1;
  border-color: rgb(52 211 153 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/20 {
  border-color: rgb(16 185 129 / 0.2);
}
.border-emerald-500\\/30 {
  border-color: rgb(16 185 129 / 0.3);
}
.border-emerald-500\\/40 {
  border-color: rgb(16 185 129 / 0.4);
}
.border-emerald-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 150 105 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/50 {
  border-color: rgb(229 231 235 / 0.5);
}
.border-gray-200\\/60 {
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-200\\/70 {
  border-color: rgb(229 231 235 / 0.7);
}
.border-gray-200\\/80 {
  border-color: rgb(229 231 235 / 0.8);
}
.border-gray-200\\/90 {
  border-color: rgb(229 231 235 / 0.9);
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-300\\/80 {
  border-color: rgb(209 213 219 / 0.8);
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(188 240 218 / var(--tw-border-opacity, 1));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(132 225 188 / var(--tw-border-opacity, 1));
}
.border-green-400 {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 141 / var(--tw-border-opacity, 1));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}
.border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity, 1));
}
.border-indigo-100 {
  --tw-border-opacity: 1;
  border-color: rgb(229 237 255 / var(--tw-border-opacity, 1));
}
.border-indigo-200 {
  --tw-border-opacity: 1;
  border-color: rgb(205 219 254 / var(--tw-border-opacity, 1));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(180 198 252 / var(--tw-border-opacity, 1));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(141 162 251 / var(--tw-border-opacity, 1));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity, 1));
}
.border-inherit {
  border-color: inherit;
}
.border-lime-300 {
  --tw-border-opacity: 1;
  border-color: rgb(190 242 100 / var(--tw-border-opacity, 1));
}
.border-lime-400 {
  --tw-border-opacity: 1;
  border-color: rgb(163 230 53 / var(--tw-border-opacity, 1));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity, 1));
}
.border-orange-200 {
  --tw-border-opacity: 1;
  border-color: rgb(252 217 189 / var(--tw-border-opacity, 1));
}
.border-orange-400 {
  --tw-border-opacity: 1;
  border-color: rgb(255 138 76 / var(--tw-border-opacity, 1));
}
.border-orange-500\\/30 {
  border-color: rgb(255 90 31 / 0.3);
}
.border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(248 180 217 / var(--tw-border-opacity, 1));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity, 1));
}
.border-pink-600 {
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(220 215 254 / var(--tw-border-opacity, 1));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity, 1));
}
.border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(74 29 150 / var(--tw-border-opacity, 1));
}
.border-red-100 {
  --tw-border-opacity: 1;
  border-color: rgb(253 232 232 / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(251 213 213 / var(--tw-border-opacity, 1));
}
.border-red-200\\/90 {
  border-color: rgb(251 213 213 / 0.9);
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(248 180 180 / var(--tw-border-opacity, 1));
}
.border-red-400 {
  --tw-border-opacity: 1;
  border-color: rgb(249 128 128 / var(--tw-border-opacity, 1));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}
.border-red-500\\/30 {
  border-color: rgb(240 82 82 / 0.3);
}
.border-red-500\\/40 {
  border-color: rgb(240 82 82 / 0.4);
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}
.border-red-900 {
  --tw-border-opacity: 1;
  border-color: rgb(119 29 29 / var(--tw-border-opacity, 1));
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-slate-100 {
  --tw-border-opacity: 1;
  border-color: rgb(241 245 249 / var(--tw-border-opacity, 1));
}
.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-slate-200\\/80 {
  border-color: rgb(226 232 240 / 0.8);
}
.border-slate-200\\/90 {
  border-color: rgb(226 232 240 / 0.9);
}
.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}
.border-slate-500\\/30 {
  border-color: rgb(100 116 139 / 0.3);
}
.border-slate-600 {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}
.border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}
.border-slate-700\\/60 {
  border-color: rgb(51 65 85 / 0.6);
}
.border-slate-800 {
  --tw-border-opacity: 1;
  border-color: rgb(30 41 59 / var(--tw-border-opacity, 1));
}
.border-teal-200 {
  --tw-border-opacity: 1;
  border-color: rgb(175 236 239 / var(--tw-border-opacity, 1));
}
.border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(126 220 226 / var(--tw-border-opacity, 1));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-200 {
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-500\\/30 {
  border-color: rgb(139 92 246 / 0.3);
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/25 {
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/40 {
  border-color: rgb(255 255 255 / 0.4);
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(250 202 21 / var(--tw-border-opacity, 1));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity, 1));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}
.border-yellow-500\\/40 {
  border-color: rgb(194 120 3 / 0.4);
}
.border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity, 1));
}
.border-b-\\[\\#EBECEF\\] {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(235 236 239 / var(--tw-border-opacity, 1));
}
.border-l-\\[\\#236DB4\\] {
  --tw-border-opacity: 1;
  border-left-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}
.border-l-sky-400 {
  --tw-border-opacity: 1;
  border-left-color: rgb(56 189 248 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#236DB4\\] {
  --tw-border-opacity: 1;
  border-top-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}
.border-t-blue-500 {
  --tw-border-opacity: 1;
  border-top-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}
.border-t-blue-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(28 100 242 / var(--tw-border-opacity, 1));
}
.border-t-indigo-600 {
  --tw-border-opacity: 1;
  border-top-color: rgb(88 80 236 / var(--tw-border-opacity, 1));
}
.border-t-transparent {
  border-top-color: transparent;
}
.border-t-white {
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#236DB4\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(35 109 180 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-blue-300 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-emerald-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1) !important;
}
.\\!bg-gray-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-red-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-red-500\\/10 {
  background-color: rgb(240 82 82 / 0.1) !important;
}
.\\!bg-slate-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-slate-800 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#0B2E63\\]\\/60 {
  background-color: rgb(11 46 99 / 0.6);
}
.bg-\\[\\#0E9F8E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 142 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b0d10\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(11 13 16 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#101216\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(16 18 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#132433\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 36 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16181c\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 28 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E1E1E\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1F5C8F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(31 92 143 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e293b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#236DB4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(35 109 180 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#236DB4\\]\\/10 {
  background-color: rgb(35 109 180 / 0.1);
}
.bg-\\[\\#236DB4\\]\\/15 {
  background-color: rgb(35 109 180 / 0.15);
}
.bg-\\[\\#236DB4\\]\\/20 {
  background-color: rgb(35 109 180 / 0.2);
}
.bg-\\[\\#236DB4\\]\\/25 {
  background-color: rgb(35 109 180 / 0.25);
}
.bg-\\[\\#236DB4\\]\\/30 {
  background-color: rgb(35 109 180 / 0.3);
}
.bg-\\[\\#236DB4\\]\\/5 {
  background-color: rgb(35 109 180 / 0.05);
}
.bg-\\[\\#236DB4\\]\\/70 {
  background-color: rgb(35 109 180 / 0.7);
}
.bg-\\[\\#2463eb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#252525\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 37 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#29a36a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(41 163 106 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2C2C2C\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(44 44 44 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2b2b2b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(43 43 43 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2d2d2d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(45 45 45 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#333\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3F63EA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(63 99 234 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3a3d44\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(58 61 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#45B369\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(69 179 105 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#667085\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(102 112 133 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#7C5CFC\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(124 92 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#8a8a8a\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(138 138 138 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#9CBDDD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(156 189 221 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#B5730B\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(181 115 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D0D6E1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(208 214 225 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E0EBF4\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(224 235 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4587A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 88 122 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4E8EF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 232 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E4F6F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(228 246 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E5E7EB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E7F6ED\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 246 237 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F1FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 241 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#E8F7EF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 247 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF2FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF2FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 242 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EAF3FB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBECEF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 236 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBF5FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EEF6FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EF4A0033\\] {
  background-color: #EF4A0033;
}
.bg-\\[\\#EF4A00\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 74 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EFF6FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F1ECFD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 236 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F1F4F8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(241 244 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F2F6FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 246 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F5F5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F6FA\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 246 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F5F9FE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 249 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7FAFD\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F7FAFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 250 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#F8FBFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 251 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FBFCFE\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(251 252 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FDF3E2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(253 243 226 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF0000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FF9F2933\\] {
  background-color: #FF9F2933;
}
.bg-\\[\\#FF9F29\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 41 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFF1F2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7edf6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 237 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e7f7f8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(231 247 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f4fd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 244 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f7f0\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(232 247 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8f7f0\\]\\/60 {
  background-color: rgb(232 247 240 / 0.6);
}
.bg-\\[\\#e9effb\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(233 239 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#edeef2\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(237 238 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eeeff1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 239 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eef5fd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(238 245 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0ecf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 236 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f6fe\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0f6fe\\]\\/95 {
  background-color: rgb(240 246 254 / 0.95);
}
.bg-\\[\\#f2ecf9\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(242 236 249 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3f4f6\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8fafc\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fcf2e3\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(252 242 227 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff3b30\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 59 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffffcc\\]\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-\\[\\#fffffff2\\] {
  background-color: #fffffff2;
}
.bg-\\[rgba\\(14\\2c 21\\2c 38\\2c 0\\.5\\)\\] {
  background-color: rgba(14,21,38,0.5);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-50\\/70 {
  background-color: rgb(255 251 235 / 0.7);
}
.bg-amber-50\\/80 {
  background-color: rgb(255 251 235 / 0.8);
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/15 {
  background-color: rgb(245 158 11 / 0.15);
}
.bg-amber-950\\/15 {
  background-color: rgb(69 26 3 / 0.15);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45 {
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80 {
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 239 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-100\\/50 {
  background-color: rgb(225 239 254 / 0.5);
}
.bg-blue-100\\/80 {
  background-color: rgb(225 239 254 / 0.8);
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(118 169 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/40 {
  background-color: rgb(235 245 255 / 0.4);
}
.bg-blue-50\\/50 {
  background-color: rgb(235 245 255 / 0.5);
}
.bg-blue-50\\/60 {
  background-color: rgb(235 245 255 / 0.6);
}
.bg-blue-50\\/70 {
  background-color: rgb(235 245 255 / 0.7);
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/15 {
  background-color: rgb(63 131 248 / 0.15);
}
.bg-blue-500\\/30 {
  background-color: rgb(63 131 248 / 0.3);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity, 1));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity, 1));
}
.bg-blue-900\\/40 {
  background-color: rgb(35 56 118 / 0.4);
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-cyan-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/40 {
  background-color: rgb(236 253 245 / 0.4);
}
.bg-emerald-50\\/50 {
  background-color: rgb(236 253 245 / 0.5);
}
.bg-emerald-50\\/60 {
  background-color: rgb(236 253 245 / 0.6);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-500\\/15 {
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20 {
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600\\/20 {
  background-color: rgb(5 150 105 / 0.2);
}
.bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100\\/80 {
  background-color: rgb(243 244 246 / 0.8);
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/50 {
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/70 {
  background-color: rgb(249 250 251 / 0.7);
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-600\\/70 {
  background-color: rgb(75 85 99 / 0.7);
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-700\\/40 {
  background-color: rgb(55 65 81 / 0.4);
}
.bg-gray-700\\/60 {
  background-color: rgb(55 65 81 / 0.6);
}
.bg-gray-700\\/70 {
  background-color: rgb(55 65 81 / 0.7);
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-800\\/40 {
  background-color: rgb(31 41 55 / 0.4);
}
.bg-gray-800\\/50 {
  background-color: rgb(31 41 55 / 0.5);
}
.bg-gray-800\\/60 {
  background-color: rgb(31 41 55 / 0.6);
}
.bg-gray-800\\/95 {
  background-color: rgb(31 41 55 / 0.95);
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-gray-900\\/40 {
  background-color: rgb(17 24 39 / 0.4);
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-gray-900\\/60 {
  background-color: rgb(17 24 39 / 0.6);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}
.bg-green-100\\/60 {
  background-color: rgb(222 247 236 / 0.6);
}
.bg-green-100\\/80 {
  background-color: rgb(222 247 236 / 0.8);
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 141 / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 247 / var(--tw-bg-opacity, 1));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity, 1));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100\\/60 {
  background-color: rgb(229 237 255 / 0.6);
}
.bg-indigo-100\\/80 {
  background-color: rgb(229 237 255 / 0.8);
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(141 162 251 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 245 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/70 {
  background-color: rgb(240 245 255 / 0.7);
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity, 1));
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity, 1));
}
.bg-indigo-950\\/40 {
  background-color: rgb(30 27 75 / 0.4);
}
.bg-inherit {
  background-color: inherit;
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}
.bg-lime-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(163 230 53 / var(--tw-bg-opacity, 1));
}
.bg-lime-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 236 220 / var(--tw-bg-opacity, 1));
}
.bg-orange-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 138 76 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 248 241 / var(--tw-bg-opacity, 1));
}
.bg-orange-500\\/15 {
  background-color: rgb(255 90 31 / 0.15);
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity, 1));
}
.bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity, 1));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 235 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-100\\/60 {
  background-color: rgb(237 235 254 / 0.6);
}
.bg-purple-100\\/80 {
  background-color: rgb(237 235 254 / 0.8);
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity, 1));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 128 128 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/60 {
  background-color: rgb(253 242 242 / 0.6);
}
.bg-red-50\\/70 {
  background-color: rgb(253 242 242 / 0.7);
}
.bg-red-50\\/80 {
  background-color: rgb(253 242 242 / 0.8);
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/15 {
  background-color: rgb(240 82 82 / 0.15);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/20 {
  background-color: rgb(224 36 36 / 0.2);
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity, 1));
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/30 {
  background-color: rgb(255 241 242 / 0.3);
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-sky-500\\/10 {
  background-color: rgb(14 165 233 / 0.1);
}
.bg-sky-500\\/15 {
  background-color: rgb(14 165 233 / 0.15);
}
.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}
.bg-slate-100\\/80 {
  background-color: rgb(241 245 249 / 0.8);
}
.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity, 1));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity, 1));
}
.bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-50\\/50 {
  background-color: rgb(248 250 252 / 0.5);
}
.bg-slate-50\\/60 {
  background-color: rgb(248 250 252 / 0.6);
}
.bg-slate-50\\/70 {
  background-color: rgb(248 250 252 / 0.7);
}
.bg-slate-50\\/80 {
  background-color: rgb(248 250 252 / 0.8);
}
.bg-slate-500\\/15 {
  background-color: rgb(100 116 139 / 0.15);
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity, 1));
}
.bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}
.bg-slate-800\\/60 {
  background-color: rgb(30 41 59 / 0.6);
}
.bg-slate-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-slate-900\\/40 {
  background-color: rgb(15 23 42 / 0.4);
}
.bg-slate-900\\/45 {
  background-color: rgb(15 23 42 / 0.45);
}
.bg-slate-900\\/50 {
  background-color: rgb(15 23 42 / 0.5);
}
.bg-slate-900\\/60 {
  background-color: rgb(15 23 42 / 0.6);
}
.bg-slate-900\\/75 {
  background-color: rgb(15 23 42 / 0.75);
}
.bg-slate-900\\/95 {
  background-color: rgb(15 23 42 / 0.95);
}
.bg-slate-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(2 6 23 / var(--tw-bg-opacity, 1));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity, 1));
}
.bg-teal-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 250 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 148 162 / var(--tw-bg-opacity, 1));
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}
.bg-violet-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-500\\/15 {
  background-color: rgb(139 92 246 / 0.15);
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/25 {
  background-color: rgb(255 255 255 / 0.25);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40 {
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/70 {
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/75 {
  background-color: rgb(255 255 255 / 0.75);
}
.bg-white\\/80 {
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95 {
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}
.bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(227 160 8 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 234 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity, 1));
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-opacity-100 {
  --tw-bg-opacity: 1;
}
.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}
.bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}
.bg-opacity-30 {
  --tw-bg-opacity: 0.3;
}
.bg-opacity-40 {
  --tw-bg-opacity: 0.4;
}
.bg-opacity-5 {
  --tw-bg-opacity: 0.05;
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-70 {
  --tw-bg-opacity: 0.7;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-opacity-95 {
  --tw-bg-opacity: 0.95;
}
.bg-\\[linear-gradient\\(\\#0b0d10_70\\%\\2c transparent\\)\\] {
  background-image: linear-gradient(#0b0d10 70%,transparent);
}
.bg-\\[linear-gradient\\(\\#F5F5F5_70\\%\\2c transparent\\)\\] {
  background-image: linear-gradient(#F5F5F5 70%,transparent);
}
.bg-\\[linear-gradient\\(\\#fff_70\\%\\2c transparent\\)\\] {
  background-image: linear-gradient(#fff 70%,transparent);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#0B2E63\\] {
  --tw-gradient-from: #0B2E63 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(11 46 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#0B2E63\\]\\/70 {
  --tw-gradient-from: rgb(11 46 99 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(11 46 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#236DB4\\] {
  --tw-gradient-from: #236DB4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(35 109 180 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F5FAFF\\] {
  --tw-gradient-from: #F5FAFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 250 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F8FBFF\\] {
  --tw-gradient-from: #F8FBFF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 251 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400 {
  --tw-gradient-from: #22d3ee var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 211 238 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: #F9FAFB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400 {
  --tw-gradient-from: #31C48D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 141 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-200 {
  --tw-gradient-from: #d9f99d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(217 249 157 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400 {
  --tw-gradient-from: #F17EB8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 126 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #E74694 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(231 70 148 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #9061F9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(144 97 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #7E3AF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 58 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-200 {
  --tw-gradient-from: #FBD5D5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 213 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400 {
  --tw-gradient-from: #F98080 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 128 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-50 {
  --tw-gradient-from: #f8fafc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-200 {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400 {
  --tw-gradient-from: #16BDCA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 189 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#0B2E63\\]\\/50 {
  --tw-gradient-to: rgb(11 46 99 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(11 46 99 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#123a72\\] {
  --tw-gradient-to: rgb(18 58 114 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #123a72 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#EEF6FF\\] {
  --tw-gradient-to: rgb(238 246 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #EEF6FF var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500 {
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-600 {
  --tw-gradient-to: rgb(8 145 178 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0891b2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-500 {
  --tw-gradient-to: rgb(14 159 110 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0E9F6E var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lime-400 {
  --tw-gradient-to: rgb(163 230 53 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a3e635 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500 {
  --tw-gradient-to: rgb(231 70 148 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E74694 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600 {
  --tw-gradient-to: rgb(126 58 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7E3AF2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-300 {
  --tw-gradient-to: rgb(248 180 180 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F8B4B4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-500 {
  --tw-gradient-to: rgb(240 82 82 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F05252 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500 {
  --tw-gradient-to: rgb(6 148 162 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0694A2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0B2E63\\]\\/80 {
  --tw-gradient-to: rgb(11 46 99 / 0.8) var(--tw-gradient-to-position);
}
.to-\\[\\#0B2E63\\]\\/85 {
  --tw-gradient-to: rgb(11 46 99 / 0.85) var(--tw-gradient-to-position);
}
.to-\\[\\#1a4a8f\\] {
  --tw-gradient-to: #1a4a8f var(--tw-gradient-to-position);
}
.to-\\[\\#1a5490\\] {
  --tw-gradient-to: #1a5490 var(--tw-gradient-to-position);
}
.to-\\[\\#2A7FCD\\] {
  --tw-gradient-to: #2A7FCD var(--tw-gradient-to-position);
}
.to-\\[\\#E6F2FF\\] {
  --tw-gradient-to: #E6F2FF var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-cyan-700 {
  --tw-gradient-to: #0e7490 var(--tw-gradient-to-position);
}
.to-gray-100 {
  --tw-gradient-to: #F3F4F6 var(--tw-gradient-to-position);
}
.to-gray-50 {
  --tw-gradient-to: #F9FAFB var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #057A55 var(--tw-gradient-to-position);
}
.to-lime-200 {
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}
.to-lime-500 {
  --tw-gradient-to: #84cc16 var(--tw-gradient-to-position);
}
.to-orange-400 {
  --tw-gradient-to: #FF8A4C var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #E74694 var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #D61F69 var(--tw-gradient-to-position);
}
.to-purple-700 {
  --tw-gradient-to: #6C2BD9 var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #E02424 var(--tw-gradient-to-position);
}
.to-slate-50 {
  --tw-gradient-to: #f8fafc var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #047481 var(--tw-gradient-to-position);
}
.to-white {
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}
.to-yellow-200 {
  --tw-gradient-to: #FCE96A var(--tw-gradient-to-position);
}
.fill-current {
  fill: currentColor;
}
.fill-cyan-600 {
  fill: #0891b2;
}
.fill-gray-600 {
  fill: #4B5563;
}
.fill-green-500 {
  fill: #0E9F6E;
}
.fill-pink-600 {
  fill: #D61F69;
}
.fill-purple-600 {
  fill: #7E3AF2;
}
.fill-red-600 {
  fill: #E02424;
}
.fill-yellow-400 {
  fill: #E3A008;
}
.stroke-\\[\\#236DB4\\] {
  stroke: #236DB4;
}
.stroke-slate-200 {
  stroke: #e2e8f0;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[11px\\] {
  padding: 11px;
}
.p-\\[2px\\] {
  padding: 2px;
}
.\\!px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.\\!px-2\\.5 {
  padding-left: 0.625rem !important;
  padding-right: 0.625rem !important;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.\\!px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.\\!px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}
.\\!py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.\\!py-0\\.5 {
  padding-top: 0.125rem !important;
  padding-bottom: 0.125rem !important;
}
.\\!py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.\\!py-2\\.5 {
  padding-top: 0.625rem !important;
  padding-bottom: 0.625rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-36 {
  padding-left: 9rem;
  padding-right: 9rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[22px\\] {
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[6px\\] {
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[9px\\] {
  padding-left: 9px;
  padding-right: 9px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[12px\\] {
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-\\[13px\\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[25px\\] {
  padding-top: 25px;
  padding-bottom: 25px;
}
.py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}
.\\!pt-0 {
  padding-top: 0px !important;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-px {
  padding-bottom: 1px;
}
.pe-1 {
  padding-inline-end: 0.25rem;
}
.pe-10 {
  padding-inline-end: 2.5rem;
}
.pe-11 {
  padding-inline-end: 2.75rem;
}
.pe-12 {
  padding-inline-end: 3rem;
}
.pe-14 {
  padding-inline-end: 3.5rem;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pl-28 {
  padding-left: 7rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-12 {
  padding-right: 3rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-28 {
  padding-right: 7rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-9 {
  padding-right: 2.25rem;
}
.ps-0 {
  padding-inline-start: 0px;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-10 {
  padding-inline-start: 2.5rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-5 {
  padding-inline-start: 1.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[14px\\] {
  padding-top: 14px;
}
.pt-\\[18px\\] {
  padding-top: 18px;
}
.pt-\\[2px\\] {
  padding-top: 2px;
}
.pt-\\[39px\\] {
  padding-top: 39px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-top {
  vertical-align: top;
}
.align-middle {
  vertical-align: middle;
}
.align-\\[-1px\\] {
  vertical-align: -1px;
}
.font-sans {
  font-family: MediumFont, Manrope, sans-serif;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10\\.5px\\] {
  font-size: 10.5px;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11\\.5px\\] {
  font-size: 11.5px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[17px\\] {
  font-size: 17px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-medium {
  font-weight: 500 !important;
}
.\\!font-semibold {
  font-weight: 600 !important;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.\\!uppercase {
  text-transform: uppercase !important;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.\\!capitalize {
  text-transform: capitalize !important;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[1\\.45\\] {
  line-height: 1.45;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[19px\\] {
  line-height: 19px;
}
.leading-\\[20px\\] {
  line-height: 20px;
}
.leading-\\[34px\\] {
  line-height: 34px;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.01em\\] {
  letter-spacing: -0.01em;
}
.tracking-\\[0\\.005em\\] {
  letter-spacing: 0.005em;
}
.tracking-\\[0\\.02em\\] {
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.03em\\] {
  letter-spacing: 0.03em;
}
.tracking-\\[0\\.04em\\] {
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.06em\\] {
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.07em\\] {
  letter-spacing: 0.07em;
}
.tracking-\\[0\\.08em\\] {
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.09em\\] {
  letter-spacing: 0.09em;
}
.tracking-\\[0\\.10em\\] {
  letter-spacing: 0.10em;
}
.tracking-\\[0\\.14em\\] {
  letter-spacing: 0.14em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-\\[\\#236DB4\\] {
  --tw-text-opacity: 1 !important;
  color: rgb(35 109 180 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-emerald-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-emerald-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-gray-800 {
  --tw-text-opacity: 1 !important;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-red-400 {
  --tw-text-opacity: 1 !important;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-red-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-slate-200 {
  --tw-text-opacity: 1 !important;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-slate-600 {
  --tw-text-opacity: 1 !important;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-slate-700 {
  --tw-text-opacity: 1 !important;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-\\[\\#00000066\\] {
  color: #00000066;
}
.text-\\[\\#000000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#030a1e\\] {
  --tw-text-opacity: 1;
  color: rgb(3 10 30 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0E8E8B\\] {
  --tw-text-opacity: 1;
  color: rgb(14 142 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0E9F8E\\] {
  --tw-text-opacity: 1;
  color: rgb(14 159 142 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0F2A52\\] {
  --tw-text-opacity: 1;
  color: rgb(15 42 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f1729\\] {
  --tw-text-opacity: 1;
  color: rgb(15 23 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#101828\\] {
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#111827\\] {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#188A4B\\] {
  --tw-text-opacity: 1;
  color: rgb(24 138 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A1A1A\\] {
  --tw-text-opacity: 1;
  color: rgb(26 26 26 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1A5A96\\] {
  --tw-text-opacity: 1;
  color: rgb(26 90 150 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1B7F4B\\] {
  --tw-text-opacity: 1;
  color: rgb(27 127 75 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1E293B\\] {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d5a95\\] {
  --tw-text-opacity: 1;
  color: rgb(29 90 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d6dc2\\] {
  --tw-text-opacity: 1;
  color: rgb(29 109 194 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1e3a8a\\] {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f2937\\] {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f7d52\\] {
  --tw-text-opacity: 1;
  color: rgb(31 125 82 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2295a0\\] {
  --tw-text-opacity: 1;
  color: rgb(34 149 160 / var(--tw-text-opacity, 1));
}
.text-\\[\\#236DB4\\] {
  --tw-text-opacity: 1;
  color: rgb(35 109 180 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2454D8\\] {
  --tw-text-opacity: 1;
  color: rgb(36 84 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2563EB\\] {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#29a36a\\] {
  --tw-text-opacity: 1;
  color: rgb(41 163 106 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3157d5\\] {
  --tw-text-opacity: 1;
  color: rgb(49 87 213 / var(--tw-text-opacity, 1));
}
.text-\\[\\#344054\\] {
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3571e9\\] {
  --tw-text-opacity: 1;
  color: rgb(53 113 233 / var(--tw-text-opacity, 1));
}
.text-\\[\\#374151\\] {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3F6FF5\\] {
  --tw-text-opacity: 1;
  color: rgb(63 111 245 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3a73ad\\] {
  --tw-text-opacity: 1;
  color: rgb(58 115 173 / var(--tw-text-opacity, 1));
}
.text-\\[\\#45B369\\] {
  --tw-text-opacity: 1;
  color: rgb(69 179 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#475569\\] {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4B5563\\] {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5F6C8D\\] {
  --tw-text-opacity: 1;
  color: rgb(95 108 141 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64748b\\] {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#667085\\] {
  --tw-text-opacity: 1;
  color: rgb(102 112 133 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B7280\\] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B7FA3\\] {
  --tw-text-opacity: 1;
  color: rgb(107 127 163 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6a41c8\\] {
  --tw-text-opacity: 1;
  color: rgb(106 65 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#70788f\\] {
  --tw-text-opacity: 1;
  color: rgb(112 120 143 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7B4FE0\\] {
  --tw-text-opacity: 1;
  color: rgb(123 79 224 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7fb3e0\\] {
  --tw-text-opacity: 1;
  color: rgb(127 179 224 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7fb4e8\\] {
  --tw-text-opacity: 1;
  color: rgb(127 180 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#818cf8\\] {
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-\\[\\#838995\\] {
  --tw-text-opacity: 1;
  color: rgb(131 137 149 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8541c8\\] {
  --tw-text-opacity: 1;
  color: rgb(133 65 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8dc5f2\\] {
  --tw-text-opacity: 1;
  color: rgb(141 197 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#98A2B3\\] {
  --tw-text-opacity: 1;
  color: rgb(152 162 179 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9CA3AF\\] {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9aa0aa\\] {
  --tw-text-opacity: 1;
  color: rgb(154 160 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B8790A\\] {
  --tw-text-opacity: 1;
  color: rgb(184 121 10 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B91C1C\\] {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF4444\\] {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF4A00\\] {
  --tw-text-opacity: 1;
  color: rgb(239 74 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF0000\\] {
  --tw-text-opacity: 1;
  color: rgb(255 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF9F29\\] {
  --tw-text-opacity: 1;
  color: rgb(255 159 41 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a1a1aa\\] {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c7cbd1\\] {
  --tw-text-opacity: 1;
  color: rgb(199 203 209 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e4d6d6\\] {
  --tw-text-opacity: 1;
  color: rgb(228 214 214 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f2930d\\] {
  --tw-text-opacity: 1;
  color: rgb(242 147 13 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f8fafc\\] {
  --tw-text-opacity: 1;
  color: rgb(248 250 252 / var(--tw-text-opacity, 1));
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-200 {
  --tw-text-opacity: 1;
  color: rgb(195 221 253 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(164 202 254 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(118 169 250 / var(--tw-text-opacity, 1));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(26 86 219 / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity, 1));
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}
.text-emerald-400 {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-gray-950 {
  --tw-text-opacity: 1;
  color: rgb(3 7 18 / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(4 108 78 / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity, 1));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity, 1));
}
.text-indigo-400 {
  --tw-text-opacity: 1;
  color: rgb(141 162 251 / var(--tw-text-opacity, 1));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(104 117 245 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity, 1));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(81 69 205 / var(--tw-text-opacity, 1));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity, 1));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity, 1));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity, 1));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity, 1));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity, 1));
}
.text-orange-400 {
  --tw-text-opacity: 1;
  color: rgb(255 138 76 / var(--tw-text-opacity, 1));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 90 31 / var(--tw-text-opacity, 1));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(208 56 1 / var(--tw-text-opacity, 1));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(180 52 3 / var(--tw-text-opacity, 1));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(231 70 148 / var(--tw-text-opacity, 1));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity, 1));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(191 18 93 / var(--tw-text-opacity, 1));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity, 1));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity, 1));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(202 191 253 / var(--tw-text-opacity, 1));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(144 97 249 / var(--tw-text-opacity, 1));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity, 1));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(108 43 217 / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(248 180 180 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(200 30 30 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity, 1));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400 {
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700 {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-sky-300 {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.text-sky-400 {
  --tw-text-opacity: 1;
  color: rgb(56 189 248 / var(--tw-text-opacity, 1));
}
.text-slate-100 {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}
.text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}
.text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-slate-800 {
  --tw-text-opacity: 1;
  color: rgb(30 41 59 / var(--tw-text-opacity, 1));
}
.text-slate-900 {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(6 148 162 / var(--tw-text-opacity, 1));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity, 1));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(3 102 114 / var(--tw-text-opacity, 1));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity, 1));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity, 1));
}
.text-transparent {
  color: transparent;
}
.text-violet-400 {
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700 {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80 {
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85 {
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90 {
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-200 {
  --tw-text-opacity: 1;
  color: rgb(252 233 106 / var(--tw-text-opacity, 1));
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(250 202 21 / var(--tw-text-opacity, 1));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(227 160 8 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(194 120 3 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(159 88 10 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(142 75 16 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.decoration-dotted {
  text-decoration-style: dotted;
}
.underline-offset-\\[3px\\] {
  text-underline-offset: 3px;
}
.placeholder-cyan-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(14 116 144 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.placeholder-green-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(4 108 78 / var(--tw-placeholder-opacity, 1));
}
.placeholder-red-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(200 30 30 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(148 163 184 / var(--tw-placeholder-opacity, 1));
}
.placeholder-slate-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(100 116 139 / var(--tw-placeholder-opacity, 1));
}
.placeholder-white::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(255 255 255 / var(--tw-placeholder-opacity, 1));
}
.placeholder-yellow-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(142 75 16 / var(--tw-placeholder-opacity, 1));
}
.caret-black {
  caret-color: #000000;
}
.caret-transparent {
  caret-color: transparent;
}
.accent-\\[\\#236DB4\\] {
  accent-color: #236DB4;
}
.accent-\\[\\#4c6ef5\\] {
  accent-color: #4c6ef5;
}
.accent-black {
  accent-color: #000000;
}
.accent-blue-500 {
  accent-color: #3F83F8;
}
.accent-blue-600 {
  accent-color: #1C64F2;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-30 {
  opacity: 0.3;
}
.opacity-40 {
  opacity: 0.4;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-\\[0\\.55\\] {
  opacity: 0.55;
}
.mix-blend-lighten {
  mix-blend-mode: lighten;
}
.\\!shadow-\\[0_0_0_3px_rgba\\(129\\2c 140\\2c 248\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 0 3px rgba(129,140,248,0.25) !important;
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-\\[0_0_0_3px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 0 0 3px rgba(35,109,180,0.15) !important;
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.\\!shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_\\#E8F7EF\\] {
  --tw-shadow: 0 0 0 3px #E8F7EF;
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_rgba\\(129\\2c 140\\2c 248\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 0 3px rgba(129,140,248,0.25);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.15\\)\\] {
  --tw-shadow: 0 0 0 3px rgba(35,109,180,0.15);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_3px_rgba\\(59\\2c 130\\2c 246\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 0 0 3px rgba(59,130,246,0.25);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.14\\)\\] {
  --tw-shadow: 0 10px 30px rgba(35,109,180,0.14);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_-10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.12\\)\\2c 0_4px_6px_-2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 10px 40px -10px rgba(0,0,0,0.12),0 4px 6px -2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 10px 40px -10px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_30px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 16px 30px rgba(15,23,42,0.08);
  --tw-shadow-colored: 0 16px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_35px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 16px 35px rgba(15,23,42,0.18);
  --tw-shadow-colored: 0 16px 35px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.25);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.05\\)\\2c 0_1px_3px_rgba\\(16\\2c 24\\2c 40\\2c 0\\.05\\)\\] {
  --tw-shadow: 0 1px 2px rgba(16,24,40,0.05),0 1px 3px rgba(16,24,40,0.05);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_45px_-20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
  --tw-shadow: 0 20px 45px -20px rgba(0,0,0,0.45);
  --tw-shadow-colored: 0 20px 45px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgba\\(14\\2c 21\\2c 38\\2c 0\\.22\\)\\2c 0_4px_16px_rgba\\(14\\2c 21\\2c 38\\2c 0\\.12\\)\\] {
  --tw-shadow: 0 24px 60px rgba(14,21,38,0.22),0 4px 16px rgba(14,21,38,0.12);
  --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color), 0 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_18px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.26\\)\\] {
  --tw-shadow: 0 8px 18px rgba(35,109,180,0.26);
  --tw-shadow-colored: 0 8px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#236DB4\\]\\/25 {
  --tw-shadow-color: rgb(35 109 180 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/10 {
  --tw-shadow-color: rgb(0 0 0 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/30 {
  --tw-shadow-color: rgb(0 0 0 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-900\\/5 {
  --tw-shadow-color: rgb(35 56 118 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-slate-950\\/50 {
  --tw-shadow-color: rgb(2 6 23 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset {
  --tw-ring-inset: inset;
}
.ring-\\[\\#236DB4\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(35 109 180 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#29a36a\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(41 163 106 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#D9EAF9\\] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 234 249 / var(--tw-ring-opacity, 1));
}
.ring-blue-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}
.ring-cyan-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}
.ring-cyan-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}
.ring-emerald-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 250 229 / var(--tw-ring-opacity, 1));
}
.ring-gray-200\\/70 {
  --tw-ring-color: rgb(229 231 235 / 0.7);
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}
.ring-gray-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}
.ring-gray-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}
.ring-gray-900 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}
.ring-pink-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity, 1));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 97 249 / var(--tw-ring-opacity, 1));
}
.ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}
.ring-slate-200 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(226 232 240 / var(--tw-ring-opacity, 1));
}
.ring-slate-200\\/80 {
  --tw-ring-color: rgb(226 232 240 / 0.8);
}
.ring-transparent {
  --tw-ring-color: transparent;
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-yellow-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity, 1));
}
.ring-offset-1 {
  --tw-ring-offset-width: 1px;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm {
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl {
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-0 {
  --tw-brightness: brightness(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.brightness-75 {
  --tw-brightness: brightness(.75);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.\\!filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[1px\\] {
  --tw-backdrop-blur: blur(1px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\] {
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[3px\\] {
  --tw-backdrop-blur: blur(3px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md {
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c text-decoration-color\\2c fill\\2c stroke\\2c box-shadow\\] {
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\2c right\\] {
  transition-property: left,right;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[stroke-dasharray\\] {
  transition-property: stroke-dasharray;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\] {
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0 {
  transition-delay: 0s;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.ps-0 {
  padding-inline-start: 0px;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.pe-1 {
  padding-inline-end: 0.25rem;
}
.ps-2 {
  padding-inline-start: 0.5rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.pe-3 {
  padding-inline-end: 0.75rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-5 {
  padding-inline-start: 1.25rem;
}
.ps-10 {
  padding-inline-start: 2.5rem;
}
.pe-10 {
  padding-inline-end: 2.5rem;
}
.pe-11 {
  padding-inline-end: 2.75rem;
}
.pe-12 {
  padding-inline-end: 3rem;
}
.pe-14 {
  padding-inline-end: 3.5rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.ms-0\\.5 {
  margin-inline-start: 0.125rem;
}
.ms-1\\.5 {
  margin-inline-start: 0.375rem;
}
[dir="rtl"] .start-0 {
  right: 0px;
}
[dir="rtl"] .end-0 {
  left: 0px;
}
[dir="ltr"] .end-0 {
  right: 0px;
}
[dir="ltr"] .start-0 {
  left: 0px;
}
[dir="rtl"] .end-3 {
  left: 0.75rem;
}
[dir="ltr"] .end-3 {
  right: 0.75rem;
}
[dir="rtl"] .end-4 {
  left: 1rem;
}
[dir="ltr"] .end-4 {
  right: 1rem;
}
[dir="ltr"] .rounded-e-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
[dir="ltr"] .rounded-s-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
[dir="rtl"] .rounded-e-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
[dir="rtl"] .rounded-s-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-s {
  border-inline-start-width: 1px;
}
[dir="rtl"] .text-start {
  text-align: right;
}
[dir="rtl"] .text-end {
  text-align: left;
}
[dir="ltr"] .text-end {
  text-align: right;
}
[dir="ltr"] .text-start {
  text-align: left;
}
.\\[animation-delay\\:-0\\.1s\\] {
  animation-delay: -0.1s;
}
.\\[animation-delay\\:-0\\.2s\\] {
  animation-delay: -0.2s;
}
.\\[appearance\\:textfield\\] {
  appearance: textfield;
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}
.\\[overflow\\:-moz-scrollbars-none\\] {
  overflow: -moz-scrollbars-none;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[text-wrap\\:balance\\] {
  text-wrap: balance;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

:root {
  --text-color: #333;
  --bg-color: #ffffff;
  --border-color: #ccc;
  --app-font-family: 'MediumFont', 'Manrope', sans-serif;
  --app-scrollbar-size: 8px;
  --app-scrollbar-radius: 20px;
  --app-scrollbar-inset: 0px;
  --app-scrollbar-track: transparent;
  --app-scrollbar-track-hover: transparent;
  --app-scrollbar-thumb: linear-gradient(#b9c2e0, #b9c2e0);
  --app-scrollbar-thumb-hover: linear-gradient(#a3add2, #a3add2);
  --app-scrollbar-thumb-active: linear-gradient(#a3add2, #a3add2);
  --app-scrollbar-thumb-shadow: none;
  --app-scrollbar-glow-hover: none;
  --app-scrollbar-glow-active: none;
  --app-scrollbar-border-content: transparent;
  --app-scrollbar-border-sidebar: transparent;
  --app-scrollbar-border-modal: transparent;
  --app-scrollbar-color-firefox: #b9c2e0 transparent;
  --app-scrollbar-color-firefox-hover: #b9c2e0 transparent;
}

body.light {
  --text-color: #333;
  --bg-color: #ffffff;
  --border-color: #ccc;
}

body.dark {
  --text-color: #ccc;
  --bg-color: #000;
  --border-color: #444;
}

body.high-contrast {
  --text-color: #fff;
  --bg-color: #000;
  --border-color: #fff;
}

body {
  color: var(--text-color);
  background-color: var(--bg-color);
  border-color: var(--border-color);
  font-family: var(--app-font-family);
}

html,
body,
#root,
body *,
#root * {
  font-family: var(--app-font-family) !important;
}

button,
input,
select,
textarea,
optgroup,
option,
label,
legend,
fieldset,
table,
th,
td,
p,
span,
a,
small,
strong,
b,
i,
em,
h1,
h2,
h3,
h4,
h5,
h6,
[class*="select"],
[class*="Select"],
.react-select__menu,
.react-select__menu *,
.react-datepicker,
.react-datepicker *,
.Toastify,
.Toastify *,
.apexcharts-canvas,
.apexcharts-canvas *,
.apexcharts-tooltip,
.apexcharts-tooltip *,
.leaflet-container,
.leaflet-container * {
  font-family: var(--app-font-family) !important;
}

input::placeholder,
input::-webkit-input-placeholder,
input::-moz-placeholder,
input:-ms-input-placeholder,
textarea::placeholder,
textarea::-webkit-input-placeholder,
textarea::-moz-placeholder,
textarea:-ms-input-placeholder,
[contenteditable="true"],
[contenteditable="true"] *,
.react-select__placeholder,
[class*="placeholder"],
[class*="Placeholder"],
.apexcharts-text,
.apexcharts-text *,
svg text,
svg tspan {
  font-family: var(--app-font-family) !important;
}

[dir="rtl"] {
  direction: rtl;
}

html[dir="rtl"] body {
  text-align: right;
}

html[dir="ltr"] body {
  text-align: left;
}

.scrollbar-container {
  direction: ltr;
}

html[dir="rtl"] .scrollbar-container {
  direction: rtl;
}

html[dir="rtl"] .scrollbar-container>* {
  direction: rtl;
}

.table-scroll,
.rtl-table-scroll {
  direction: ltr;
  overflow-x: auto;
}

html[dir="rtl"] .table-scroll,
html[dir="rtl"] .rtl-table-scroll {
  direction: rtl;
}

html[dir="rtl"] .table-scroll>table,
html[dir="rtl"] .table-scroll table,
html[dir="rtl"] .rtl-table-scroll>table,
html[dir="rtl"] .rtl-table-scroll table {
  direction: rtl;
  text-align: start;
}

html[dir="rtl"] .rtl-keep-ltr {
  direction: ltr;
  text-align: left;
}

html[dir="rtl"] input,
html[dir="rtl"] textarea {
  text-align: right;
}

html[dir="ltr"] input,
html[dir="ltr"] textarea {
  text-align: left;
}

.mixed-dir {
  unicode-bidi: plaintext;
  text-align: start;
}

.custom-zoom-control {
  top: 60px;
}

.leaflet-left .leaflet-control {
  margin-left: 16px !important
}

.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control {
  display: flex;
  gap: 10px;
  flex-direction: column;
  border: unset;
  margin-right: 13px;
}

.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control .leaflet-control-zoom-in,
.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control .leaflet-control-zoom-out {
  width: 40px;
  height: 32px;
  border-radius: 4px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px #606C800D;
}

.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-layers .leaflet-control {
  width: 40px;
  height: 32px;
  border-radius: 4px;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px 0px #606C800D;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 13px;
}

.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-layers .leaflet-control .leaflet-control-layers-toggle {
  width: 20px;
  height: 20px;
}

.zoom-container {
  top: 50px !important
}

.leaflet-top {
  top: 5px !important;
}

.map-with-date-panel .leaflet-top {
  top: 92px !important;
}

.react-datepicker {
  border: 0px !important;
  display: inline-block !important;
}

.react-datepicker-popper .react-datepicker__month-container {
  float: left;
}

.react-datepicker-popper .react-datepicker__time-container {
  float: right;
}

.react-datepicker__header {
  background-color: #236DB4 !important;
  border-top-left-radius: 10px !important;
  border-top-right-radius: 10px !important;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: #FFF !important;
}

/* Backdrop ? dir ltr keeps ring/logo centered in Arabic/RTL layouts */
.loader-backdrop {
  position: fixed;
  inset: 0;
  direction: ltr;
  background: rgba(255, 255, 255, 0.75);
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Loader Container */
.circular-loader {
  position: relative;
  width: 80px;
  height: 80px;
}

/* Rotating Ring */
.loader-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 4px solid rgba(59, 130, 246, 0.2);
  border-top-color: #2563eb;
  animation: spin 1.1s linear infinite;
}

/* Center Logo */
.bluefield-logo-center {
  position: absolute;
  inset: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  /* animation: logoPulse 1.5s ease-in-out infinite; */
}

/* Ring Rotation */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Logo Pulse */
@keyframes logoPulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.4));
  }

  50% {
    transform: translate(-50%, -50%) scale(1.08);
    filter: drop-shadow(0 0 12px rgba(37, 99, 235, 0.8));
  }

  100% {
    transform: translate(-50%, -50%) scale(1);
    filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.4));
  }
}

/* ==========================================================================
   Standardized Checkbox Styling (Light, Dark, High-Contrast)
   ========================================================================== */
input[type="checkbox"] {
  appearance: none !important;
  width: 1.125rem !important;
  /* 18px */
  height: 1.125rem !important;
  /* 18px */
  border: 2px solid #cbd5e1 !important;
  /* slate-300 */
  border-radius: 4px !important;
  outline: none !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  cursor: pointer !important;
  background-color: #ffffff !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  vertical-align: middle !important;
}

input[type="checkbox"].hidden,
input[type="checkbox"][hidden] {
  display: none !important;
}

input[type="checkbox"]:hover:not(:disabled) {
  border-color: #236DB4 !important;
  /* Brand hover */
  box-shadow: 0 0 0 4px rgba(35, 109, 180, 0.15) !important;
}

input[type="checkbox"]:checked {
  background-color: #236DB4 !important;
  border-color: #236DB4 !important;
}

input[type="checkbox"]:checked::after {
  content: "" !important;
  width: 5px !important;
  height: 9px !important;
  border: solid white !important;
  border-width: 0 2px 2px 0 !important;
  transform: rotate(45deg) translate(-0.5px, -1px) !important;
  display: block !important;
}

/* Checkbox Dark Mode Styles */
body.dark input[type="checkbox"] {
  background-color: #1e293b !important;
  /* Slate 800 */
  border-color: #475569 !important;
  /* Slate 600 */
}

body.dark input[type="checkbox"]:hover:not(:disabled) {
  border-color: #236DB4 !important;
  /* Brand hover */
  box-shadow: 0 0 0 4px rgba(35, 109, 180, 0.25) !important;
}

body.dark input[type="checkbox"]:checked {
  background-color: #236DB4 !important;
  border-color: #236DB4 !important;
}

/* Checkbox High Contrast Styles */
body.high-contrast input[type="checkbox"] {
  background-color: #000000 !important;
  border: 2px solid #ffffff !important;
}

body.high-contrast input[type="checkbox"]:hover:not(:disabled) {
  border-color: #ffff00 !important;
  /* High contrast yellow */
  box-shadow: 0 0 0 4px rgba(255, 255, 0, 0.4) !important;
}

body.high-contrast input[type="checkbox"]:checked {
  background-color: #ffff00 !important;
  border-color: #ffff00 !important;
}

body.high-contrast input[type="checkbox"]:checked::after {
  border-color: #000000 !important;
}

/* Checkbox Disabled State */
input[type="checkbox"]:disabled {
  background-color: #f1f5f9 !important;
  border-color: #e2e8f0 !important;
  cursor: not-allowed !important;
  opacity: 0.7 !important;
}

body.dark input[type="checkbox"]:disabled {
  background-color: #334155 !important;
  border-color: #1e293b !important;
}

body.high-contrast input[type="checkbox"]:disabled {
  background-color: #000000 !important;
  border-color: #888888 !important;
  opacity: 0.5 !important;
}

input[type="checkbox"]:disabled:checked::after {
  border-color: #94a3b8 !important;
}

body.dark input[type="checkbox"]:disabled:checked::after {
  border-color: #475569 !important;
}

/* ==========================================================================
   Standardized Select / Dropdown Styling (Non-multiple native selects)
   ========================================================================== */
select:not([multiple]) {
  appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 0.75rem center !important;
  background-size: 1rem !important;
  padding: 0 2.5rem 0 1rem !important;
  height: 42px !important;
  line-height: 42px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 10px !important;
  background-color: #ffffff !important;
  color: #334155 !important;
  font-size: 15px !important;
  font-family: inherit !important;
  font-weight: 500 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer !important;
  box-sizing: border-box !important;
}

[dir="rtl"] select:not([multiple]) {
  background-position: left 0.75rem center !important;
  padding: 0 1rem 0 2.5rem !important;
}

select:not([multiple]):hover:not(:disabled) {
  border-color: #6366f1 !important;
}

select:not([multiple]):focus {
  outline: none !important;
  border-color: #6366f1 !important;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;
}

/* Select Dark Mode Styles */
body.dark select:not([multiple]) {
  background-color: #1e293b !important;
  border-color: #475569 !important;
  color: #f1f5f9 !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) !important;
}

body.dark select:not([multiple]):hover:not(:disabled) {
  border-color: #818cf8 !important;
}

body.dark select:not([multiple]):focus {
  border-color: #818cf8 !important;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.25) !important;
}

/* Select High Contrast Styles */
body.high-contrast select:not([multiple]) {
  background-color: #000000 !important;
  border: 2px solid #ffffff !important;
  color: #ffffff !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
}

body.high-contrast select:not([multiple]):hover:not(:disabled) {
  border-color: #ffff00 !important;
}

body.high-contrast select:not([multiple]):focus {
  border-color: #ffff00 !important;
  box-shadow: 0 0 0 3px rgba(255, 255, 0, 0.4) !important;
}

/* Select Disabled State */
select:not([multiple]):disabled {
  background-color: #f1f5f9 !important;
  color: #94a3b8 !important;
  border-color: #e2e8f0 !important;
  cursor: not-allowed !important;
}

body.dark select:not([multiple]):disabled {
  background-color: #334155 !important;
  border-color: #475569 !important;
  color: #64748b !important;
}

body.high-contrast select:not([multiple]):disabled {
  background-color: #000000 !important;
  border-color: #888888 !important;
  color: #888888 !important;
  opacity: 0.5 !important;
}

/* Close button visuals are centralized in src/components/common/ModalCloseButton.jsx */

/* Sonner toast colors aligned with prior react-toastify defaults */
:root {
  --success-bg: #07bc0c;
  --success-border: #07bc0c;
  --success-text: #ffffff;

  --error-bg: #e74c3c;
  --error-border: #e74c3c;
  --error-text: #ffffff;

  --warning-bg: #f1c40f;
  --warning-border: #f1c40f;
  --warning-text: #111827;

  --info-bg: #3498db;
  --info-border: #3498db;
  --info-text: #ffffff;
}

/* ==========================================================================
   Batch A: Shared Responsive Header/Layout Contract
   Safe override layer for tablet/mobile consistency across modules.
   ========================================================================== */

/* Base row behavior (desktop-first, non-breaking) */
.page-header-row,
.page-filter-row,
.page-action-row,
.list-meta-row {
  width: 100%;
  min-width: 0;
  gap: 12px;
}

.page-filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
}

.page-action-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
}

.list-meta-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.list-meta-left,
.list-meta-right {
  min-width: 0;
}

/* Tablet and below: predictable stacking, cleaner wraps */
@media (max-width: 1024px) {
  .page-header-row,
  .page-filter-row,
  .page-action-row,
  .list-meta-row {
    gap: 10px;
  }

  .page-action-row {
    justify-content: flex-start;
  }
}

/* Mobile: strict vertical flow contract */
@media (max-width: 640px) {
  .page-header-row,
  .page-filter-row,
  .page-action-row,
  .list-meta-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 10px;
  }

  .list-meta-left,
  .list-meta-right {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .page-action-row > * {
    width: 100%;
  }

  .page-action-row > *.action-icon-only,
  .page-action-row > .action-icon-only {
    width: auto;
  }
}

/* Mobile-only: keep scroll behavior but hide visible scrollbar chrome. */
@media (max-width: 640px) {
  .mobile-hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .mobile-hide-scrollbar::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
}

/* Strong mobile first-paint scrollbar suppression for known scroll shells */
@media (max-width: 640px) {
  .mobile-hide-scrollbar,
  .mobile-hide-scrollbar * {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  .mobile-hide-scrollbar::-webkit-scrollbar,
  .mobile-hide-scrollbar *::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    background: transparent !important;
  }
}

/* Slider drawer keyframes and class */
@keyframes slideInFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.animate-slide-in-right {
  animation: slideInFromRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

/* Draws attention to a just-revealed per-column funnel filter icon */
@keyframes filterIconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.35);
  }
}

.animate-filter-pulse {
  animation: filterIconPulse 0.45s ease-in-out 2;
}

/* Indeterminate bar for a bulk export that is queued but not started yet --
   a 0%-wide determinate bar would read as stuck. */
@keyframes bulkExportIndeterminate {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(300%);
  }
}

.animate-bulk-export-indeterminate {
  animation: bulkExportIndeterminate 1.4s ease-in-out infinite;
}

/* Regular action buttons only. Tabs, icons and text-only controls do not opt in. */
button[data-button-intent="primary"] {
  --action-ring: #93c5fd;
  --action-bg: #236db4;
  --action-hover: #1d5a96;
  --action-text: #ffffff;
}
button[data-button-intent="danger"] {
  --action-ring: #fca5a5;
  --action-bg: #dc2626;
  --action-hover: #b91c1c;
  --action-text: #ffffff;
}
button[data-button-intent="warning"] {
  --action-ring: #fde68a;
  --action-bg: #facc15;
  --action-hover: #eab308;
  --action-text: #422006;
}
button[data-button-intent="success"] {
  --action-ring: #86efac;
  --action-bg: #15803d;
  --action-hover: #166534;
  --action-text: #ffffff;
}
button[data-button-intent] {
  /* The semantic fill overrides the variant; its focus halo must do so too. */
  --tw-ring-color: var(--action-ring) !important;
  background-color: var(--action-bg) !important;
  background-image: none !important;
  color: var(--action-text) !important;
  border-color: var(--action-bg) !important;
}
button[data-button-intent] > span:not([class*="bg-"]),
button[data-button-intent] svg {
  color: inherit !important;
}
button[data-button-intent]:hover:not(:disabled):not([aria-disabled="true"]) {
  background-color: var(--action-hover) !important;
  border-color: var(--action-hover) !important;
}
button[data-button-intent]:focus-visible {
  outline: 2px solid var(--action-ring);
  outline-offset: 3px;
}
body.high-contrast button[data-button-intent],
.high-contrast button[data-button-intent] {
  border: 2px solid var(--action-text) !important;
}
@media (forced-colors: active) {
  button[data-button-intent] {
    color: ButtonText !important;
    background-color: ButtonFace !important;
    border-color: ButtonText !important;
    forced-color-adjust: auto;
  }
}

/* Shared toolbar controls: outlined Column Filters and neutral Columns. */
button[data-table-control] {
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 40px;
  height: 40px;
  padding: 0 12px;
  border: 1px solid !important;
  border-radius: 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  background-image: none !important;
}
button[data-table-control="filters"][aria-pressed="true"],
button[data-table-control="columns"][aria-expanded="true"] {
  color: #236db4 !important;
  background-color: #eaf3fb !important;
  border-color: #236db4 !important;
}
button[data-table-control="filters"],
button[data-table-control="columns"] {
  color: #334155 !important;
  background-color: #ffffff !important;
  border-color: #e2e8f0 !important;
}
button[data-table-control="columns"] > span[class*="bg-"] {
  color: #526783 !important;
  background-color: #f1f5f9 !important;
  border-radius: 9999px;
  font-size: 11px;
  line-height: 20px;
  height: 20px;
  padding: 0 6px;
  flex-shrink: 0;
}
button[data-table-control] svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: inherit;
}
button[data-table-control="filters"][aria-pressed="true"]:hover:not(:disabled) { background-color: #dbeafe !important; }
button[data-table-control="filters"][aria-pressed="false"]:hover:not(:disabled) { background-color: #f8fafc !important; }
button[data-table-control="columns"][aria-expanded="false"]:hover:not(:disabled) { background-color: #f8fafc !important; }
button[data-table-control="columns"][aria-expanded="true"]:hover:not(:disabled) { background-color: #dbeafe !important; }
button[data-table-control]:focus-visible {
  outline: 2px solid #236db4;
  outline-offset: 2px;
}
@media (min-width: 640px) {
  button[data-table-control] { min-height: 36px; height: 36px; }
}
@media (max-width: 639px) {
  button[data-table-control] { padding-inline: 8px; font-size: 12px; }
}
body.dark button[data-table-control],
.dark-mode button[data-table-control] {
  color: #93c5fd !important;
  background-color: #1e293b !important;
  border-color: #64748b !important;
}
body.dark button[data-table-control="columns"] > span[class*="bg-"],
.dark-mode button[data-table-control="columns"] > span[class*="bg-"] {
  color: #cbd5e1 !important;
  background-color: #334155 !important;
}
body.dark button[data-table-control]:hover:not(:disabled),
.dark-mode button[data-table-control]:hover:not(:disabled) { background-color: #334155 !important; }
body.high-contrast button[data-table-control],
.high-contrast button[data-table-control] {
  color: #ffffff !important;
  background-color: #000000 !important;
  border-color: #ffffff !important;
}
@media (forced-colors: active) {
  button[data-table-control] {
    color: ButtonText !important;
    background-color: ButtonFace !important;
    border-color: ButtonText !important;
  }
}

button[data-table-control="filters"] > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.marker\\:text-\\[\\#236DB4\\] *::marker {
  color: rgb(35 109 180 );
}

.marker\\:text-\\[\\#236DB4\\]::marker {
  color: rgb(35 109 180 );
}

.placeholder\\:font-light::placeholder {
  font-weight: 300;
}

.placeholder\\:text-gray-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-600::placeholder {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-slate-400::placeholder {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.placeholder\\:opacity-50::placeholder {
  opacity: 0.5;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:bottom-\\[-5px\\]::before {
  content: var(--tw-content);
  bottom: -5px;
}

.before\\:left-1\\/2::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:left-\\[-5px\\]::before {
  content: var(--tw-content);
  left: -5px;
}

.before\\:right-\\[-5px\\]::before {
  content: var(--tw-content);
  right: -5px;
}

.before\\:top-1\\/2::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:top-\\[-5px\\]::before {
  content: var(--tw-content);
  top: -5px;
}

.before\\:h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:-translate-x-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rotate-45::before {
  content: var(--tw-content);
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:border::before {
  content: var(--tw-content);
  border-width: 1px;
}

.before\\:border-b-0::before {
  content: var(--tw-content);
  border-bottom-width: 0px;
}

.before\\:border-l-0::before {
  content: var(--tw-content);
  border-left-width: 0px;
}

.before\\:border-r-0::before {
  content: var(--tw-content);
  border-right-width: 0px;
}

.before\\:border-t-0::before {
  content: var(--tw-content);
  border-top-width: 0px;
}

.before\\:border-\\[\\#236DB4\\]::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}

.before\\:bg-\\[\\#f0f6fe\\]::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(240 246 254 / var(--tw-bg-opacity, 1));
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:left-\\[2px\\]::after {
  content: var(--tw-content);
  left: 2px;
}

.after\\:left-\\[4px\\]::after {
  content: var(--tw-content);
  left: 4px;
}

.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}

.after\\:top-\\[2px\\]::after {
  content: var(--tw-content);
  top: 2px;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:h-6::after {
  content: var(--tw-content);
  height: 1.5rem;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.first\\:ml-0:first-child {
  margin-left: 0px;
}

.first\\:mt-0:first-child {
  margin-top: 0px;
}

.first\\:rounded-t-lg:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.first\\:border-t-0:first-child {
  border-top-width: 0px;
}

.first\\:pl-4:first-child {
  padding-left: 1rem;
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:mr-0:last-child {
  margin-right: 0px;
}

.last\\:rounded-b-lg:last-child {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.last\\:pr-4:last-child {
  padding-right: 1rem;
}

.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.even\\:bg-gray-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.even\\:bg-slate-50\\/60:nth-child(even) {
  background-color: rgb(248 250 252 / 0.6);
}

.required\\:border:required {
  border-width: 1px;
}

.focus-within\\:z-\\[280\\]:focus-within {
  z-index: 280;
}

.focus-within\\:border-\\[\\#236DB4\\]:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-blue-400:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(118 169 250 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-blue-500:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-gray-300:focus-within {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.focus-within\\:shadow-\\[0_0_0_3px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.22\\)\\]:focus-within {
  --tw-shadow: 0 0 0 3px rgba(35,109,180,0.22);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus-within\\:outline-none:focus-within {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-within\\:ring-1:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-\\[\\#236DB4\\]\\/15:focus-within {
  --tw-ring-color: rgb(35 109 180 / 0.15);
}

.focus-within\\:ring-blue-400:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-gray-100:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}

.hover\\:z-\\[280\\]:hover {
  z-index: 280;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover {
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-not-allowed:hover {
  cursor: not-allowed;
}

.hover\\:cursor-pointer:hover {
  cursor: pointer;
}

.hover\\:border-0:hover {
  border-width: 0px;
}

.hover\\:\\!border-\\[\\#1d5a96\\]:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(29 90 150 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:border-\\[\\#236DB4\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#236DB4\\]\\/50:hover {
  border-color: rgb(35 109 180 / 0.5);
}

.hover\\:border-\\[\\#475569\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#93C5FD\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#94a3b8\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(148 163 184 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#BEDAF0\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(190 218 240 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#BFE6E4\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(191 230 228 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#D3E7FB\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(211 231 251 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#D9CCFA\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(217 204 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#F7E2BD\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(247 226 189 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(164 202 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-100:hover {
  --tw-border-opacity: 1;
  border-color: rgb(253 232 232 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(251 213 213 / var(--tw-border-opacity, 1));
}

.hover\\:border-red-500\\/40:hover {
  border-color: rgb(240 82 82 / 0.4);
}

.hover\\:border-slate-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}

.hover\\:border-slate-500:hover {
  --tw-border-opacity: 1;
  border-color: rgb(100 116 139 / var(--tw-border-opacity, 1));
}

.hover\\:\\!bg-\\[\\#1d5a96\\]:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(29 90 150 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-blue-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-emerald-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-emerald-500\\/20:hover {
  background-color: rgb(16 185 129 / 0.2) !important;
}

.hover\\:\\!bg-gray-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-red-100:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-red-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-red-500\\/20:hover {
  background-color: rgb(240 82 82 / 0.2) !important;
}

.hover\\:\\!bg-slate-50:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-slate-700:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:bg-\\[\\#16181c\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 24 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1B5690\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(27 86 144 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1a4d78\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 77 120 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1d5992\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 89 146 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1d5a95\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 90 149 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1d5a96\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 90 150 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1d5c99\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 92 153 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1d5d9e\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 93 158 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1f2126\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 33 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#236DB4\\]\\/10:hover {
  background-color: rgb(35 109 180 / 0.1);
}

.hover\\:bg-\\[\\#236DB4\\]\\/5:hover {
  background-color: rgb(35 109 180 / 0.05);
}

.hover\\:bg-\\[\\#3a3a3a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 58 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#3aa05b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(58 160 91 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#D6E7F9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(214 231 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E0EBF4\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(224 235 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#E4F6F5\\]\\/70:hover {
  background-color: rgb(228 246 245 / 0.7);
}

.hover\\:bg-\\[\\#EAF3FB\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 243 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#EAF3FB\\]\\/60:hover {
  background-color: rgb(234 243 251 / 0.6);
}

.hover\\:bg-\\[\\#EBF5FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F1ECFD\\]\\/70:hover {
  background-color: rgb(241 236 253 / 0.7);
}

.hover\\:bg-\\[\\#F1F4F8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 244 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#F1F7FD\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 247 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#FDF3E2\\]\\/70:hover {
  background-color: rgb(253 243 226 / 0.7);
}

.hover\\:bg-\\[\\#e60000\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 0 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e8f7f0\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(232 247 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f1f5f9\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f28d12\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(242 141 18 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[rgba\\(35\\2c 109\\2c 180\\2c 0\\.08\\)\\]:hover {
  background-color: rgba(35,109,180,0.08);
}

.hover\\:bg-amber-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(225 239 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(118 169 250 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/40:hover {
  background-color: rgb(235 245 255 / 0.4);
}

.hover\\:bg-blue-50\\/50:hover {
  background-color: rgb(235 245 255 / 0.5);
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(35 56 118 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-cyan-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-500\\/20:hover {
  background-color: rgb(16 185 129 / 0.2);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50\\/70:hover {
  background-color: rgb(249 250 251 / 0.7);
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700\\/50:hover {
  background-color: rgb(55 65 81 / 0.5);
}

.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(81 69 205 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lime-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(38 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(240 82 82 / 0.1);
}

.hover\\:bg-red-500\\/25:hover {
  background-color: rgb(240 82 82 / 0.25);
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sky-500\\/10:hover {
  background-color: rgb(14 165 233 / 0.1);
}

.hover\\:bg-sky-500\\/20:hover {
  background-color: rgb(14 165 233 / 0.2);
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-100\\/60:hover {
  background-color: rgb(241 245 249 / 0.6);
}

.hover\\:bg-slate-100\\/70:hover {
  background-color: rgb(241 245 249 / 0.7);
}

.hover\\:bg-slate-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-50\\/50:hover {
  background-color: rgb(248 250 252 / 0.5);
}

.hover\\:bg-slate-50\\/60:hover {
  background-color: rgb(248 250 252 / 0.6);
}

.hover\\:bg-slate-50\\/70:hover {
  background-color: rgb(248 250 252 / 0.7);
}

.hover\\:bg-slate-50\\/80:hover {
  background-color: rgb(248 250 252 / 0.8);
}

.hover\\:bg-slate-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-slate-800\\/60:hover {
  background-color: rgb(30 41 59 / 0.6);
}

.hover\\:bg-slate-900:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-teal-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-white\\/15:hover {
  background-color: rgb(255 255 255 / 0.15);
}

.hover\\:bg-white\\/60:hover {
  background-color: rgb(255 255 255 / 0.6);
}

.hover\\:bg-white\\/80:hover {
  background-color: rgb(255 255 255 / 0.8);
}

.hover\\:bg-white\\/85:hover {
  background-color: rgb(255 255 255 / 0.85);
}

.hover\\:bg-white\\/90:hover {
  background-color: rgb(255 255 255 / 0.9);
}

.hover\\:bg-white\\/95:hover {
  background-color: rgb(255 255 255 / 0.95);
}

.hover\\:bg-yellow-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(227 160 8 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-zinc-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gradient-to-br:hover {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.hover\\:from-\\[\\#2a7dd4\\]:hover {
  --tw-gradient-from: #2a7dd4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(42 125 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-\\[\\#236DB4\\]:hover {
  --tw-gradient-to: #236DB4 var(--tw-gradient-to-position);
}

.hover\\:text-\\[\\#101828\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(16 24 40 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#1b5691\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(27 86 145 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#1d5a96\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(29 90 150 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#236DB4\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(35 109 180 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#475569\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#4B5563\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#e4d6d6\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(228 214 214 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-400:hover {
  --tw-text-opacity: 1;
  color: rgb(118 169 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(26 86 219 / var(--tw-text-opacity, 1));
}

.hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}

.hover\\:text-emerald-800:hover {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 108 78 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(81 69 205 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(200 30 30 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-500:hover {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-sky-300:hover {
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-500:hover {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-600:hover {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-700:hover {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.hover\\:text-slate-900:hover {
  --tw-text-opacity: 1;
  color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.hover\\:opacity-90:hover {
  opacity: 0.9;
}

.hover\\:shadow:hover {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-2xl:hover {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_0_0_3px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.22\\)\\]:hover {
  --tw-shadow: 0 0 0 3px rgba(35,109,180,0.22);
  --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_6px_16px_rgba\\(35\\2c 109\\2c 180\\2c 0\\.12\\)\\]:hover {
  --tw-shadow: 0 6px 16px rgba(35,109,180,0.12);
  --tw-shadow-colored: 0 6px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:z-10:focus {
  z-index: 10;
}

.focus\\:border-\\[\\#236DB4\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(35 109 180 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#4c6ef5\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(76 110 245 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#5da4df\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(93 164 223 / var(--tw-border-opacity, 1));
}

.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(164 202 254 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(118 169 250 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(28 100 242 / var(--tw-border-opacity, 1));
}

.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}

.focus\\:border-gray-300:focus {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}

.focus\\:border-green-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}

.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.focus\\:bg-white:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:text-cyan-700:focus {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}

.focus\\:text-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.focus\\:\\!shadow-none:focus {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:\\!ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#236DB4\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(35 109 180 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[\\#236DB4\\]\\/20:focus {
  --tw-ring-color: rgb(35 109 180 / 0.2);
}

.focus\\:ring-\\[\\#236DB4\\]\\/30:focus {
  --tw-ring-color: rgb(35 109 180 / 0.3);
}

.focus\\:ring-\\[\\#236DB4\\]\\/40:focus {
  --tw-ring-color: rgb(35 109 180 / 0.4);
}

.focus\\:ring-\\[\\#3F6FF5\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 111 245 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[\\#4c6ef5\\]\\/15:focus {
  --tw-ring-color: rgb(76 110 245 / 0.15);
}

.focus\\:ring-\\[\\#EAF3FB\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(234 243 251 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-amber-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 191 36 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-black\\/20:focus {
  --tw-ring-color: rgb(0 0 0 / 0.2);
}

.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(195 221 253 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 131 248 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(63 131 248 / 0.2);
}

.focus\\:ring-blue-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 100 242 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 66 159 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(103 232 249 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 211 238 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-cyan-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-gray-900:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 240 218 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 225 188 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-green-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 198 252 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(141 162 251 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 249 157 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-lime-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(190 242 100 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-lime-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(163 230 53 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-lime-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 209 232 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 217 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 126 184 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-pink-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 215 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 191 253 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(172 148 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 97 249 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 232 232 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 180 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-900:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 220 226 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 189 202 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-teal-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-white:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-yellow-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-yellow-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-yellow-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-opacity-50:focus {
  --tw-ring-opacity: 0.5;
}

.focus\\:ring-opacity-75:focus {
  --tw-ring-opacity: 0.75;
}

.focus\\:ring-offset-0:focus {
  --tw-ring-offset-width: 0px;
}

.focus\\:ring-offset-1:focus {
  --tw-ring-offset-width: 1px;
}

.focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}

.focus\\:ring-offset-gray-800:focus {
  --tw-ring-offset-color: #1F2937;
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-0:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-\\[\\#236DB4\\]\\/30:focus-visible {
  --tw-ring-color: rgb(35 109 180 / 0.3);
}

.focus-visible\\:ring-\\[\\#236DB4\\]\\/40:focus-visible {
  --tw-ring-color: rgb(35 109 180 / 0.4);
}

.focus-visible\\:ring-\\[\\#236DB4\\]\\/50:focus-visible {
  --tw-ring-color: rgb(35 109 180 / 0.5);
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.active\\:scale-95:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
  cursor: grabbing;
}

.active\\:bg-\\[\\#164267\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(22 66 103 / var(--tw-bg-opacity, 1));
}

.active\\:bg-\\[\\#184a7d\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(24 74 125 / var(--tw-bg-opacity, 1));
}

.active\\:bg-\\[\\#e2e8f0\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-900:active {
  --tw-bg-opacity: 1;
  background-color: rgb(23 23 23 / var(--tw-bg-opacity, 1));
}

.enabled\\:cursor-pointer:enabled {
  cursor: pointer;
}

.enabled\\:hover\\:bg-blue-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-cyan-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-cyan-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(21 94 117 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-gray-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-gray-900:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-green-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-green-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(3 84 63 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-indigo-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-lime-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-pink-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-purple-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(85 33 181 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-red-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-red-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(155 28 28 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-slate-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-slate-700:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-teal-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-yellow-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-yellow-500:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity, 1));
}

.enabled\\:hover\\:bg-gradient-to-bl:hover:enabled {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-br:hover:enabled {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-l:hover:enabled {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:from-teal-200:hover:enabled {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.enabled\\:hover\\:to-lime-200:hover:enabled {
  --tw-gradient-to: #d9f99d var(--tw-gradient-to-position);
}

.enabled\\:hover\\:text-cyan-700:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}

.enabled\\:hover\\:text-gray-700:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.enabled\\:hover\\:text-gray-900:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:cursor-wait:disabled {
  cursor: wait;
}

.disabled\\:bg-slate-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.disabled\\:opacity-30:disabled {
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.disabled\\:opacity-70:disabled {
  opacity: 0.7;
}

.disabled\\:hover\\:border-slate-200:hover:disabled {
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}

.disabled\\:hover\\:bg-\\[\\#236DB4\\]:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(35 109 180 / var(--tw-bg-opacity, 1));
}

.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}

.disabled\\:hover\\:bg-white:hover:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.disabled\\:hover\\:text-slate-400:hover:disabled {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.disabled\\:hover\\:text-slate-500:hover:disabled {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.disabled\\:hover\\:text-slate-600:hover:disabled {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.group:first-child .group-first\\:hidden {
  display: none;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:first\\:rounded-bl-lg:first-child {
  border-bottom-left-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:last\\:rounded-br-lg:last-child {
  border-bottom-right-radius: 0.5rem;
}

.group\\/activities:hover .group-hover\\/activities\\:visible {
  visibility: visible;
}

.group\\/activities:hover .group-hover\\/activities\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/row:hover .group-hover\\/row\\:bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-blue-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(118 169 250 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-slate-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}

.group:hover .group-hover\\:bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/activities:hover .group-hover\\/activities\\:opacity-100 {
  opacity: 1;
}

.group:hover .group-hover\\:brightness-100 {
  --tw-brightness: brightness(1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.group:focus .group-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.group:focus .group-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group:focus .group-focus\\:ring-cyan-500\\/25 {
  --tw-ring-color: rgb(6 182 212 / 0.25);
}

.group:focus .group-focus\\:ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.group:enabled:hover .group-enabled\\:group-hover\\:bg-opacity-0 {
  --tw-bg-opacity: 0;
}

.group:enabled:hover .group-enabled\\:group-hover\\:text-inherit {
  color: inherit;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2 {
  top: 50%;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:left-0 {
  left: 0px;
}

.peer:focus ~ .peer-focus\\:top-2 {
  top: 0.5rem;
}

.peer:focus ~ .peer-focus\\:-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.peer:focus ~ .peer-focus\\:text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}

.peer:focus ~ .peer-focus\\:text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.dark\\:block:is(.dark *) {
  display: block;
}

.dark\\:hidden:is(.dark *) {
  display: none;
}

.dark\\:divide-gray-700:is(.dark *) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity, 1));
}

.dark\\:border-none:is(.dark *) {
  border-style: none;
}

.dark\\:border-\\[\\#1d5a96\\]:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(29 90 150 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(146 64 14 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-900\\/50:is(.dark *) {
  border-color: rgb(120 53 15 / 0.5);
}

.dark\\:border-blue-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(26 86 219 / var(--tw-border-opacity, 1));
}

.dark\\:border-cyan-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(34 211 238 / var(--tw-border-opacity, 1));
}

.dark\\:border-cyan-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}

.dark\\:border-cyan-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(8 145 178 / var(--tw-border-opacity, 1));
}

.dark\\:border-emerald-800\\/40:is(.dark *) {
  border-color: rgb(6 95 70 / 0.4);
}

.dark\\:border-gray-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-600\\/50:is(.dark *) {
  border-color: rgb(75 85 99 / 0.5);
}

.dark\\:border-gray-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity, 1));
}

.dark\\:border-gray-900:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 141 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(88 80 236 / var(--tw-border-opacity, 1));
}

.dark\\:border-lime-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(101 163 13 / var(--tw-border-opacity, 1));
}

.dark\\:border-pink-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(249 128 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-500:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity, 1));
}

.dark\\:border-red-800\\/50:is(.dark *) {
  border-color: rgb(155 28 28 / 0.5);
}

.dark\\:border-slate-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(71 85 105 / var(--tw-border-opacity, 1));
}

.dark\\:border-slate-700:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(4 116 129 / var(--tw-border-opacity, 1));
}

.dark\\:border-teal-800:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(5 80 92 / var(--tw-border-opacity, 1));
}

.dark\\:border-white:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-400:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity, 1));
}

.dark\\:border-yellow-600:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity, 1));
}

.dark\\:\\!bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1)) !important;
}

.dark\\:bg-\\[\\#1f1f1f\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 31 31 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#236DB4\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 109 180 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#2d2d2d\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(45 45 45 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#45B369\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(69 179 105 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#FF0000\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#FF9F29\\]:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 159 41 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-amber-900\\/30:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:bg-amber-900\\/40:is(.dark *) {
  background-color: rgb(120 53 15 / 0.4);
}

.dark\\:bg-amber-900\\/50:is(.dark *) {
  background-color: rgb(120 53 15 / 0.5);
}

.dark\\:bg-amber-950\\/30:is(.dark *) {
  background-color: rgb(69 26 3 / 0.3);
}

.dark\\:bg-amber-950\\/50:is(.dark *) {
  background-color: rgb(69 26 3 / 0.5);
}

.dark\\:bg-black:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-900\\/20:is(.dark *) {
  background-color: rgb(35 56 118 / 0.2);
}

.dark\\:bg-blue-900\\/30:is(.dark *) {
  background-color: rgb(35 56 118 / 0.3);
}

.dark\\:bg-blue-900\\/40:is(.dark *) {
  background-color: rgb(35 56 118 / 0.4);
}

.dark\\:bg-blue-900\\/50:is(.dark *) {
  background-color: rgb(35 56 118 / 0.5);
}

.dark\\:bg-blue-950\\/50:is(.dark *) {
  background-color: rgb(23 37 84 / 0.5);
}

.dark\\:bg-cyan-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-cyan-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-cyan-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-cyan-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-emerald-900\\/40:is(.dark *) {
  background-color: rgb(6 78 59 / 0.4);
}

.dark\\:bg-emerald-950\\/40:is(.dark *) {
  background-color: rgb(2 44 34 / 0.4);
}

.dark\\:bg-emerald-950\\/50:is(.dark *) {
  background-color: rgb(2 44 34 / 0.5);
}

.dark\\:bg-gray-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-400:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-600\\/70:is(.dark *) {
  background-color: rgb(75 85 99 / 0.7);
}

.dark\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-700\\/40:is(.dark *) {
  background-color: rgb(55 65 81 / 0.4);
}

.dark\\:bg-gray-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-800\\/30:is(.dark *) {
  background-color: rgb(31 41 55 / 0.3);
}

.dark\\:bg-gray-800\\/50:is(.dark *) {
  background-color: rgb(31 41 55 / 0.5);
}

.dark\\:bg-gray-800\\/60:is(.dark *) {
  background-color: rgb(31 41 55 / 0.6);
}

.dark\\:bg-gray-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-gray-900\\/80:is(.dark *) {
  background-color: rgb(17 24 39 / 0.8);
}

.dark\\:bg-green-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-green-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(1 71 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lime-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-lime-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-orange-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 90 31 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-pink-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-pink-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 29 150 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-purple-900\\/40:is(.dark *) {
  background-color: rgb(74 29 150 / 0.4);
}

.dark\\:bg-red-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(119 29 29 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-red-900\\/30:is(.dark *) {
  background-color: rgb(119 29 29 / 0.3);
}

.dark\\:bg-red-950\\/50:is(.dark *) {
  background-color: rgb(69 10 10 / 0.5);
}

.dark\\:bg-red-950\\/70:is(.dark *) {
  background-color: rgb(69 10 10 / 0.7);
}

.dark\\:bg-slate-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-800:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-slate-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-teal-900\\/40:is(.dark *) {
  background-color: rgb(1 68 81 / 0.4);
}

.dark\\:bg-teal-900\\/50:is(.dark *) {
  background-color: rgb(1 68 81 / 0.5);
}

.dark\\:bg-transparent:is(.dark *) {
  background-color: transparent;
}

.dark\\:bg-white:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-100:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-200:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-yellow-900:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(99 49 18 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-opacity-70:is(.dark *) {
  --tw-bg-opacity: 0.7;
}

.dark\\:bg-opacity-80:is(.dark *) {
  --tw-bg-opacity: 0.8;
}

.dark\\:fill-gray-300:is(.dark *) {
  fill: #D1D5DB;
}

.dark\\:\\!text-red-400:is(.dark *) {
  --tw-text-opacity: 1 !important;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1)) !important;
}

.dark\\:text-amber-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(195 221 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(164 202 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(118 169 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(207 250 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(21 94 117 / var(--tw-text-opacity, 1));
}

.dark\\:text-cyan-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(22 78 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.dark\\:text-gray-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(49 196 141 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity, 1));
}

.dark\\:text-lime-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity, 1));
}

.dark\\:text-lime-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(63 98 18 / var(--tw-text-opacity, 1));
}

.dark\\:text-lime-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(54 83 20 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(202 191 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(74 29 150 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(248 180 180 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(249 128 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-100:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(241 245 249 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(203 213 225 / var(--tw-text-opacity, 1));
}

.dark\\:text-slate-400:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(175 236 239 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-300:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(126 220 226 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-200:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(252 233 106 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-600:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(159 88 10 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-800:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity, 1));
}

.dark\\:text-yellow-900:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder-gray-400:is(.dark *)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}

.dark\\:mix-blend-color:is(.dark *) {
  mix-blend-mode: color;
}

.dark\\:shadow-sm-light:is(.dark *) {
  --tw-shadow: 0 2px 5px 0px rgba(255, 255, 255, 0.08);
  --tw-shadow-colored: 0 2px 5px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:ring-cyan-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-400:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-700\\/70:is(.dark *) {
  --tw-ring-color: rgb(55 65 81 / 0.7);
}

.dark\\:ring-gray-800:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-gray-900:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-green-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-pink-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-purple-600:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-red-700:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-yellow-500:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-offset-blue-700:is(.dark *) {
  --tw-ring-offset-color: #1A56DB;
}

.dark\\:ring-offset-cyan-600:is(.dark *) {
  --tw-ring-offset-color: #0891b2;
}

.dark\\:ring-offset-gray-800:is(.dark *) {
  --tw-ring-offset-color: #1F2937;
}

.dark\\:ring-offset-gray-900:is(.dark *) {
  --tw-ring-offset-color: #111827;
}

.dark\\:ring-offset-green-600:is(.dark *) {
  --tw-ring-offset-color: #057A55;
}

.dark\\:ring-offset-green-800:is(.dark *) {
  --tw-ring-offset-color: #03543F;
}

.dark\\:ring-offset-indigo-700:is(.dark *) {
  --tw-ring-offset-color: #5145CD;
}

.dark\\:ring-offset-lime-700:is(.dark *) {
  --tw-ring-offset-color: #4d7c0f;
}

.dark\\:ring-offset-pink-600:is(.dark *) {
  --tw-ring-offset-color: #D61F69;
}

.dark\\:ring-offset-purple-600:is(.dark *) {
  --tw-ring-offset-color: #7E3AF2;
}

.dark\\:ring-offset-red-600:is(.dark *) {
  --tw-ring-offset-color: #E02424;
}

.dark\\:ring-offset-red-900:is(.dark *) {
  --tw-ring-offset-color: #771D1D;
}

.dark\\:ring-offset-teal-600:is(.dark *) {
  --tw-ring-offset-color: #047481;
}

.dark\\:ring-offset-yellow-400:is(.dark *) {
  --tw-ring-offset-color: #E3A008;
}

.odd\\:dark\\:bg-gray-800:is(.dark *):nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.even\\:dark\\:bg-gray-700:is(.dark *):nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:border-gray-500:hover:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:\\!bg-red-950\\/30:hover:is(.dark *) {
  background-color: rgb(69 10 10 / 0.3) !important;
}

.dark\\:hover\\:bg-\\[\\#1d5a96\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(29 90 150 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#3a3a3a\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 58 58 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#3aa05b\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(58 160 91 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#e60000\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(230 0 0 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#f28d12\\]:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(242 141 18 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-amber-900\\/30:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.3);
}

.dark\\:hover\\:bg-amber-900\\/60:hover:is(.dark *) {
  background-color: rgb(120 53 15 / 0.6);
}

.dark\\:hover\\:bg-blue-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-900:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(35 56 118 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-blue-900\\/30:hover:is(.dark *) {
  background-color: rgb(35 56 118 / 0.3);
}

.dark\\:hover\\:bg-cyan-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-cyan-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-emerald-900\\/30:hover:is(.dark *) {
  background-color: rgb(6 78 59 / 0.3);
}

.dark\\:hover\\:bg-gray-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-600:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-600\\/50:hover:is(.dark *) {
  background-color: rgb(75 85 99 / 0.5);
}

.dark\\:hover\\:bg-gray-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-700\\/40:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.4);
}

.dark\\:hover\\:bg-gray-700\\/50:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.5);
}

.dark\\:hover\\:bg-gray-700\\/60:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}

.dark\\:hover\\:bg-gray-700\\/80:hover:is(.dark *) {
  background-color: rgb(55 65 81 / 0.8);
}

.dark\\:hover\\:bg-gray-800:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-gray-900:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-green-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-indigo-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-lime-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-pink-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-purple-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-red-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-red-900\\/30:hover:is(.dark *) {
  background-color: rgb(119 29 29 / 0.3);
}

.dark\\:hover\\:bg-slate-700:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-slate-700\\/50:hover:is(.dark *) {
  background-color: rgb(51 65 85 / 0.5);
}

.dark\\:hover\\:bg-teal-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-teal-900\\/60:hover:is(.dark *) {
  background-color: rgb(1 68 81 / 0.6);
}

.dark\\:hover\\:bg-yellow-300:hover:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:text-blue-400:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(118 169 250 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-100:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-gray-300:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-slate-200:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-blue-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-cyan-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-green-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-red-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-yellow-500:focus:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:bg-cyan-600:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:bg-gray-600:focus:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:focus\\:text-white:focus:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:ring-blue-400:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-blue-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 131 248 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-blue-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 100 242 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-blue-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 86 219 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-blue-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 66 159 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-cyan-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-cyan-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(8 145 178 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-cyan-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 116 144 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-cyan-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(21 94 117 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-gray-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-gray-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-gray-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-gray-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-gray-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-green-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-green-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-green-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 108 78 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-green-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-indigo-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-lime-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 124 15 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-lime-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(63 98 18 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-pink-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-pink-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 18 93 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-pink-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 21 75 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-purple-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-purple-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(85 33 181 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-purple-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 29 150 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-400:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(155 28 28 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-red-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-teal-600:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-teal-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 102 114 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-teal-800:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 80 92 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-yellow-400:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-yellow-500:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-yellow-700:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(142 75 16 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-yellow-900:focus:is(.dark *) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 49 18 / var(--tw-ring-opacity, 1));
}

.dark\\:focus\\:ring-offset-gray-800:focus:is(.dark *) {
  --tw-ring-offset-color: #1F2937;
}

.dark\\:focus-visible\\:ring-offset-gray-900:focus-visible:is(.dark *) {
  --tw-ring-offset-color: #111827;
}

.dark\\:enabled\\:hover\\:border-cyan-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(14 116 144 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-gray-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-green-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-indigo-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(81 69 205 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-lime-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(77 124 15 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-pink-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(191 18 93 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-red-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(200 30 30 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-teal-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(3 102 114 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:border-yellow-700:hover:enabled:is(.dark *) {
  --tw-border-opacity: 1;
  border-color: rgb(142 75 16 / var(--tw-border-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-cyan-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 116 144 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-gray-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-green-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-indigo-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(81 69 205 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-lime-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(77 124 15 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-pink-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(191 18 93 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-purple-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-red-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-teal-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 102 114 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:bg-yellow-700:hover:enabled:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(142 75 16 / var(--tw-bg-opacity, 1));
}

.enabled\\:dark\\:hover\\:bg-gray-700:hover:is(.dark *):enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:enabled\\:hover\\:text-white:hover:enabled:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.enabled\\:dark\\:hover\\:text-white:hover:is(.dark *):enabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.disabled\\:dark\\:text-gray-500:is(.dark *):disabled {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-blue-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-cyan-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(103 232 249 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-500:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-600:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-700:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-gray-700\\/60:is(.dark *) {
  background-color: rgb(55 65 81 / 0.6);
}

.group:hover .dark\\:group-hover\\:bg-gray-800\\/60:is(.dark *) {
  background-color: rgb(31 41 55 / 0.6);
}

.group:hover .dark\\:group-hover\\:bg-green-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-indigo-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-lime-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(190 242 100 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-pink-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-purple-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-red-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-teal-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:bg-yellow-300:is(.dark *) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-white:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:focus .dark\\:group-focus\\:ring-gray-800\\/70:is(.dark *) {
  --tw-ring-color: rgb(31 41 55 / 0.7);
}

.peer:focus ~ .peer-focus\\:dark\\:text-blue-500:is(.dark *) {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity, 1));
}

@media (max-width: 900px) {

  .max-\\[900px\\]\\:flex {
    display: flex;
  }

  .max-\\[900px\\]\\:w-auto {
    width: auto;
  }

  .max-\\[900px\\]\\:w-full {
    width: 100%;
  }

  .max-\\[900px\\]\\:flex-none {
    flex: none;
  }

  .max-\\[900px\\]\\:shrink-0 {
    flex-shrink: 0;
  }

  .max-\\[900px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .max-\\[900px\\]\\:flex-row {
    flex-direction: row;
  }

  .max-\\[900px\\]\\:flex-col {
    flex-direction: column;
  }

  .max-\\[900px\\]\\:items-center {
    align-items: center;
  }

  .max-\\[900px\\]\\:gap-1 {
    gap: 0.25rem;
  }

  .max-\\[900px\\]\\:gap-3 {
    gap: 0.75rem;
  }

  .max-\\[900px\\]\\:gap-y-3 {
    row-gap: 0.75rem;
  }

  .max-\\[900px\\]\\:overflow-x-auto {
    overflow-x: auto;
  }

  .max-\\[900px\\]\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .max-\\[900px\\]\\:whitespace-nowrap {
    white-space: nowrap;
  }

  .max-\\[900px\\]\\:border-b {
    border-bottom-width: 1px;
  }

  .max-\\[900px\\]\\:border-l-0 {
    border-left-width: 0px;
  }

  .max-\\[900px\\]\\:border-r-0 {
    border-right-width: 0px;
  }

  .max-\\[900px\\]\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .max-\\[900px\\]\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .max-\\[900px\\]\\:pb-1\\.5 {
    padding-bottom: 0.375rem;
  }
}

@media not all and (min-width: 640px) {

  .max-sm\\:hidden {
    display: none;
  }

  .max-sm\\:h-7 {
    height: 1.75rem;
  }

  .max-sm\\:h-8 {
    height: 2rem;
  }

  .max-sm\\:h-9 {
    height: 2.25rem;
  }

  .max-sm\\:w-10 {
    width: 2.5rem;
  }

  .max-sm\\:w-full {
    width: 100%;
  }

  .max-sm\\:max-w-\\[108px\\] {
    max-width: 108px;
  }

  .max-sm\\:items-stretch {
    align-items: stretch;
  }

  .max-sm\\:gap-2 {
    gap: 0.5rem;
  }

  .max-sm\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .max-sm\\:p-0\\.5 {
    padding: 0.125rem;
  }

  .max-sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .max-sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .max-sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 320px) {

  .xsm\\:w-\\[700px\\] {
    width: 700px;
  }

  .xsm\\:flex-row {
    flex-direction: row;
  }

  .xsm\\:justify-start {
    justify-content: flex-start;
  }
}

@media (min-width: 380px) {

  .min-\\[380px\\]\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .min-\\[380px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 420px) {

  .min-\\[420px\\]\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 640px) {

  .sm\\:sticky {
    position: sticky;
  }

  .sm\\:left-0 {
    left: 0px;
  }

  .sm\\:left-16 {
    left: 4rem;
  }

  .sm\\:left-3 {
    left: 0.75rem;
  }

  .sm\\:right-0 {
    right: 0px;
  }

  .sm\\:right-16 {
    right: 4rem;
  }

  .sm\\:right-3 {
    right: 0.75rem;
  }

  .sm\\:top-16 {
    top: 4rem;
  }

  .sm\\:z-20 {
    z-index: 20;
  }

  .sm\\:z-\\[1\\] {
    z-index: 1;
  }

  .sm\\:order-1 {
    order: 1;
  }

  .sm\\:col-auto {
    grid-column: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:m-0 {
    margin: 0px;
  }

  .sm\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:-mt-10 {
    margin-top: -2.5rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-20 {
    margin-bottom: 5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:me-2 {
    margin-inline-end: 0.5rem;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:ms-auto {
    margin-inline-start: auto;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-1 {
    margin-top: 0.25rem;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:contents {
    display: contents;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:\\!h-8 {
    height: 2rem !important;
  }

  .sm\\:\\!h-9 {
    height: 2.25rem !important;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-8 {
    height: 2rem;
  }

  .sm\\:h-9 {
    height: 2.25rem;
  }

  .sm\\:h-\\[15px\\] {
    height: 15px;
  }

  .sm\\:h-\\[340px\\] {
    height: 340px;
  }

  .sm\\:h-\\[420px\\] {
    height: 420px;
  }

  .sm\\:h-\\[50dvh\\] {
    height: 50dvh;
  }

  .sm\\:h-\\[88vh\\] {
    height: 88vh;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:max-h-72 {
    max-height: 18rem;
  }

  .sm\\:max-h-\\[360px\\] {
    max-height: 360px;
  }

  .sm\\:max-h-\\[90dvh\\] {
    max-height: 90dvh;
  }

  .sm\\:max-h-\\[90vh\\] {
    max-height: 90vh;
  }

  .sm\\:max-h-\\[92vh\\] {
    max-height: 92vh;
  }

  .sm\\:\\!min-h-\\[36px\\] {
    min-height: 36px !important;
  }

  .sm\\:min-h-0 {
    min-height: 0px;
  }

  .sm\\:min-h-10 {
    min-height: 2.5rem;
  }

  .sm\\:min-h-\\[300px\\] {
    min-height: 300px;
  }

  .sm\\:min-h-\\[40px\\] {
    min-height: 40px;
  }

  .sm\\:min-h-\\[420px\\] {
    min-height: 420px;
  }

  .sm\\:\\!w-8 {
    width: 2rem !important;
  }

  .sm\\:\\!w-9 {
    width: 2.25rem !important;
  }

  .sm\\:\\!w-auto {
    width: auto !important;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-44 {
    width: 11rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-52 {
    width: 13rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-64 {
    width: 16rem;
  }

  .sm\\:w-7 {
    width: 1.75rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-8 {
    width: 2rem;
  }

  .sm\\:w-80 {
    width: 20rem;
  }

  .sm\\:w-\\[108px\\] {
    width: 108px;
  }

  .sm\\:w-\\[15px\\] {
    width: 15px;
  }

  .sm\\:w-\\[16\\%\\] {
    width: 16%;
  }

  .sm\\:w-\\[170px\\] {
    width: 170px;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-\\[219px\\] {
    width: 219px;
  }

  .sm\\:w-\\[220px\\] {
    width: 220px;
  }

  .sm\\:w-\\[260px\\] {
    width: 260px;
  }

  .sm\\:w-\\[28\\%\\] {
    width: 28%;
  }

  .sm\\:w-\\[320px\\] {
    width: 320px;
  }

  .sm\\:w-\\[400px\\] {
    width: 400px;
  }

  .sm\\:w-\\[420px\\] {
    width: 420px;
  }

  .sm\\:w-\\[520px\\] {
    width: 520px;
  }

  .sm\\:w-\\[56\\%\\] {
    width: 56%;
  }

  .sm\\:w-\\[560px\\] {
    width: 560px;
  }

  .sm\\:w-\\[72px\\] {
    width: 72px;
  }

  .sm\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .sm\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-fit {
    width: fit-content;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:min-w-\\[110px\\] {
    min-width: 110px;
  }

  .sm\\:min-w-\\[130px\\] {
    min-width: 130px;
  }

  .sm\\:min-w-\\[150px\\] {
    min-width: 150px;
  }

  .sm\\:min-w-\\[190px\\] {
    min-width: 190px;
  }

  .sm\\:min-w-\\[220px\\] {
    min-width: 220px;
  }

  .sm\\:min-w-\\[260px\\] {
    min-width: 260px;
  }

  .sm\\:min-w-\\[34px\\] {
    min-width: 34px;
  }

  .sm\\:min-w-\\[9rem\\] {
    min-width: 9rem;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-3xl {
    max-width: 48rem;
  }

  .sm\\:max-w-5xl {
    max-width: 64rem;
  }

  .sm\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .sm\\:max-w-\\[320px\\] {
    max-width: 320px;
  }

  .sm\\:max-w-\\[360px\\] {
    max-width: 360px;
  }

  .sm\\:max-w-\\[380px\\] {
    max-width: 380px;
  }

  .sm\\:max-w-\\[420px\\] {
    max-width: 420px;
  }

  .sm\\:max-w-\\[520px\\] {
    max-width: 520px;
  }

  .sm\\:max-w-\\[560px\\] {
    max-width: 560px;
  }

  .sm\\:max-w-full {
    max-width: 100%;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-max {
    max-width: max-content;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-none {
    max-width: none;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:flex-initial {
    flex: 0 1 auto;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:shrink-0 {
    flex-shrink: 0;
  }

  .sm\\:basis-52 {
    flex-basis: 13rem;
  }

  .sm\\:translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-95 {
    --tw-scale-x: .95;
    --tw-scale-y: .95;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,1fr) auto minmax(0,1fr);
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:items-stretch {
    align-items: stretch;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:\\!gap-2 {
    gap: 0.5rem !important;
  }

  .sm\\:gap-1 {
    gap: 0.25rem;
  }

  .sm\\:gap-1\\.5 {
    gap: 0.375rem;
  }

  .sm\\:gap-2 {
    gap: 0.5rem;
  }

  .sm\\:gap-2\\.5 {
    gap: 0.625rem;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:gap-5 {
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:gap-\\[27px\\] {
    gap: 27px;
  }

  .sm\\:gap-\\[38px\\] {
    gap: 38px;
  }

  .sm\\:gap-x-4 {
    column-gap: 1rem;
  }

  .sm\\:gap-y-0 {
    row-gap: 0px;
  }

  .sm\\:space-y-16 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(4rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-3 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-6 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
  }

  .sm\\:self-auto {
    align-self: auto;
  }

  .sm\\:\\!overflow-hidden {
    overflow: hidden !important;
  }

  .sm\\:overflow-hidden {
    overflow: hidden;
  }

  .sm\\:overflow-y-auto {
    overflow-y: auto;
  }

  .sm\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .sm\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .sm\\:whitespace-nowrap {
    white-space: nowrap;
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-1\\.5 {
    padding: 0.375rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:\\!px-3 {
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
  }

  .sm\\:\\!px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .sm\\:px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .sm\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .sm\\:pb-8 {
    padding-bottom: 2rem;
  }

  .sm\\:pl-10 {
    padding-left: 2.5rem;
  }

  .sm\\:pl-3 {
    padding-left: 0.75rem;
  }

  .sm\\:pr-0 {
    padding-right: 0px;
  }

  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }

  .sm\\:pr-3 {
    padding-right: 0.75rem;
  }

  .sm\\:pr-8 {
    padding-right: 2rem;
  }

  .sm\\:ps-0 {
    padding-inline-start: 0px;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:pt-10 {
    padding-top: 2.5rem;
  }

  .sm\\:pt-3 {
    padding-top: 0.75rem;
  }

  .sm\\:pt-4 {
    padding-top: 1rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:\\!text-sm {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-\\[11px\\] {
    font-size: 11px;
  }

  .sm\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .sm\\:text-\\[13px\\] {
    font-size: 13px;
  }

  .sm\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .sm\\:text-\\[15px\\] {
    font-size: 15px;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[30px\\] {
    font-size: 30px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .sm\\:shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:ps-0 {
    padding-inline-start: 0px;
  }

  .sm\\:me-2 {
    margin-inline-end: 0.5rem;
  }

  .sm\\:ms-auto {
    margin-inline-start: auto;
  }

  .sm\\:first\\:pl-6:first-child {
    padding-left: 1.5rem;
  }

  .sm\\:last\\:pr-6:last-child {
    padding-right: 1.5rem;
  }
}

@media (min-width: 768px) {

  .md\\:pointer-events-auto {
    pointer-events: auto;
  }

  .md\\:inset-0 {
    inset: 0px;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:max-h-full {
    max-height: 100%;
  }

  .md\\:min-h-0 {
    min-height: 0px;
  }

  .md\\:w-16 {
    width: 4rem;
  }

  .md\\:w-36 {
    width: 9rem;
  }

  .md\\:w-48 {
    width: 12rem;
  }

  .md\\:w-\\[230px\\] {
    width: 230px;
  }

  .md\\:w-\\[75\\%\\] {
    width: 75%;
  }

  .md\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:max-w-4xl {
    max-width: 56rem;
  }

  .md\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:basis-auto {
    flex-basis: auto;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:overflow-visible {
    overflow: visible;
  }

  .md\\:overflow-y-auto {
    overflow-y: auto;
  }

  .md\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .md\\:rounded-none {
    border-radius: 0px;
  }

  .md\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:border-0 {
    border-width: 0px;
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .md\\:pr-2 {
    padding-right: 0.5rem;
  }

  .md\\:ps-0 {
    padding-inline-start: 0px;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:font-medium {
    font-weight: 500;
  }

  .md\\:text-cyan-700 {
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity, 1));
  }

  .md\\:ps-0 {
    padding-inline-start: 0px;
  }

  .md\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .md\\:hover\\:text-cyan-700:hover {
    --tw-text-opacity: 1;
    color: rgb(14 116 144 / var(--tw-text-opacity, 1));
  }

  .md\\:dark\\:hover\\:bg-transparent:hover:is(.dark *) {
    background-color: transparent;
  }

  .md\\:dark\\:hover\\:text-white:hover:is(.dark *) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  }
}

@media (min-width: 1214px) {

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .lg\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .lg\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:contents {
    display: contents;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-10 {
    height: 2.5rem;
  }

  .lg\\:h-8 {
    height: 2rem;
  }

  .lg\\:h-9 {
    height: 2.25rem;
  }

  .lg\\:h-\\[46px\\] {
    height: 46px;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:min-h-\\[36px\\] {
    min-height: 36px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-10 {
    width: 2.5rem;
  }

  .lg\\:w-9 {
    width: 2.25rem;
  }

  .lg\\:w-\\[200px\\] {
    width: 200px;
  }

  .lg\\:w-\\[250px\\] {
    width: 250px;
  }

  .lg\\:w-\\[320px\\] {
    width: 320px;
  }

  .lg\\:w-\\[42px\\] {
    width: 42px;
  }

  .lg\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .lg\\:w-\\[55\\%\\] {
    width: 55%;
  }

  .lg\\:w-\\[560px\\] {
    width: 560px;
  }

  .lg\\:w-\\[65\\%\\] {
    width: 65%;
  }

  .lg\\:w-\\[75\\%\\] {
    width: 75%;
  }

  .lg\\:w-\\[80px\\] {
    width: 80px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:min-w-\\[11rem\\] {
    min-width: 11rem;
  }

  .lg\\:max-w-\\[240px\\] {
    max-width: 240px;
  }

  .lg\\:max-w-\\[260px\\] {
    max-width: 260px;
  }

  .lg\\:max-w-\\[560px\\] {
    max-width: 560px;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:flex-none {
    flex: none;
  }

  .lg\\:shrink-0 {
    flex-shrink: 0;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-2 {
    gap: 0.5rem;
  }

  .lg\\:gap-3 {
    gap: 0.75rem;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:space-x-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0px * var(--tw-space-x-reverse));
    margin-left: calc(0px * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:overflow-hidden {
    overflow: hidden;
  }

  .lg\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lg\\:whitespace-nowrap {
    white-space: nowrap;
  }

  .lg\\:p-1 {
    padding: 0.25rem;
  }

  .lg\\:p-\\[14px\\] {
    padding: 14px;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .lg\\:text-\\[12px\\] {
    font-size: 12px;
  }

  .lg\\:text-\\[34px\\] {
    font-size: 34px;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 1280px) {

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:col-start-1 {
    grid-column-start: 1;
  }

  .xl\\:mb-4 {
    margin-bottom: 1rem;
  }

  .xl\\:ml-auto {
    margin-left: auto;
  }

  .xl\\:mr-auto {
    margin-right: auto;
  }

  .xl\\:inline-flex {
    display: inline-flex;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-24 {
    height: 6rem;
  }

  .xl\\:h-9 {
    height: 2.25rem;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:min-h-\\[190px\\] {
    min-height: 190px;
  }

  .xl\\:w-\\[220px\\] {
    width: 220px;
  }

  .xl\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:flex-1 {
    flex: 1 1;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:gap-4 {
    gap: 1rem;
  }

  .xl\\:p-6 {
    padding: 1.5rem;
  }

  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:text-\\[14px\\] {
    font-size: 14px;
  }
}

.ltr\\:right-3:where([dir="ltr"], [dir="ltr"] *) {
  right: 0.75rem;
}

.rtl\\:left-3:where([dir="rtl"], [dir="rtl"] *) {
  left: 0.75rem;
}

.rtl\\:-translate-x-1:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:-translate-x-6:where([dir="rtl"], [dir="rtl"] *) {
  --tw-translate-x: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:justify-start:where([dir="rtl"], [dir="rtl"] *) {
  justify-content: flex-start;
}

.rtl\\:space-x-reverse:where([dir="rtl"], [dir="rtl"] *) > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 1;
}

.rtl\\:text-left:where([dir="rtl"], [dir="rtl"] *) {
  text-align: left;
}

.rtl\\:text-right:where([dir="rtl"], [dir="rtl"] *) {
  text-align: right;
}

.\\[\\&\\:\\:-webkit-inner-spin-button\\]\\:appearance-none::-webkit-inner-spin-button {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-outer-spin-button\\]\\:appearance-none::-webkit-outer-spin-button {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!hidden::-webkit-scrollbar {
  display: none !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!h-0::-webkit-scrollbar {
  height: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!w-0::-webkit-scrollbar {
  width: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!bg-transparent::-webkit-scrollbar {
  background-color: transparent !important;
}

.\\[\\&\\>\\*\\]\\:pointer-events-none>* {
  pointer-events: none;
}

.\\[\\&\\>\\*\\]\\:cursor-grab>* {
  cursor: grab;
}

.\\[\\&\\>\\*\\]\\:first\\:rounded-t-lg:first-child>* {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:rounded-b-lg:last-child>* {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:border-b-0:last-child>* {
  border-bottom-width: 0px;
}

.\\[\\&\\>div\\]\\:\\!block>div {
  display: block !important;
}

.\\[\\&\\>div\\]\\:\\!inline-block>div {
  display: inline-block !important;
}

.\\[\\&\\>div\\]\\:\\!w-full>div {
  width: 100% !important;
}

.\\[\\&_a\\:hover\\]\\:opacity-90 a:hover {
  opacity: 0.9;
}

.\\[\\&_a\\]\\:font-medium a {
  font-weight: 500;
}

.\\[\\&_a\\]\\:text-\\[\\#236DB4\\] a {
  --tw-text-opacity: 1;
  color: rgb(35 109 180 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\]\\:underline a {
  text-decoration-line: underline;
}

.\\[\\&_button\\]\\:min-h-\\[40px\\] button {
  min-height: 40px;
}

.\\[\\&_button\\]\\:min-w-\\[40px\\] button {
  min-width: 40px;
}

@media (min-width: 640px) {

  .sm\\:\\[\\&_button\\]\\:min-h-\\[36px\\] button {
    min-height: 36px;
  }

  .sm\\:\\[\\&_button\\]\\:min-w-\\[36px\\] button {
    min-width: 36px;
  }
}

.\\[\\&_tbody_button\\]\\:\\!h-8 tbody button {
  height: 2rem !important;
}

.\\[\\&_tbody_button\\]\\:\\!min-h-\\[32px\\] tbody button {
  min-height: 32px !important;
}

.\\[\\&_tbody_button\\]\\:\\!px-3 tbody button {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}

.\\[\\&_tbody_button\\]\\:\\!py-0 tbody button {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.\\[\\&_td\\]\\:\\!px-4 td {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.\\[\\&_td\\]\\:\\!py-3 td {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.\\[\\&_th\\]\\:\\!px-4 th {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}

.\\[\\&_th\\]\\:\\!py-3 th {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4CAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,0BAAc;EAAd,uBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,cAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAKhB;EAAA,aAAoR;EAApR,cAAoR;EAApR,aAAoR;EAApR,eAAoR;EAApR,mBAAoR;EAApR,uBAAoR;EAApR,qBAAoR;EAApR,iBAAoR;EAApR,sBAAoR;EAApR,4DAAoR;EAApR,kBAAoR;EAApR,4DAAoR;EAApR,qCAAoR;EAApR,0DAAoR;EAApR,uGAAoR;EAApR,6BAAoR;EAApR,uQAAoR;EAApR,wBAAoR;EAApR,wDAAoR;EAApR;AAAoR;AAApR;EAAA,uBAAoR;EAApR,kBAAoR;EAApR,4DAAoR;EAApR,sCAAoR;EAApR,2DAAoR;EAApR;AAAoR;AAIpR;EAAA,eAA6N;EAA7N,qBAA6N;EAA7N,iBAA6N;EAA7N,sBAA6N;EAA7N,4DAA6N;EAA7N,kBAA6N;EAA7N,4DAA6N;EAA7N,qBAA6N;EAA7N,sBAA6N;EAA7N,qBAA6N;EAA7N,wBAA6N;EAA7N,mBAA6N;EAA7N,oBAA6N;EAA7N,gBAA6N;EAA7N,wBAA6N;EAA7N,wDAA6N;EAA7N;AAA6N;AAA7N;EAAA,uBAA6N;EAA7N,kBAA6N;EAA7N,4DAA6N;EAA7N,qCAA6N;EAA7N,0DAA6N;EAA7N;AAA6N;AAA7N;;EAAA;IAAA,qBAA6N;IAA7N;EAA6N;AAAA;AAI7N;EAAA,eAA+L;EAA/L,qBAA+L;EAA/L,iBAA+L;EAA/L,sBAA+L;EAA/L,0DAA+L;EAA/L,qEAA+L;EAA/L,8DAA+L;EAA/L,mEAA+L;EAA/L,mEAA+L;EAA/L,0DAA+L;EAA/L,qBAA+L;EAA/L,sBAA+L;EAA/L,qBAA+L;EAA/L,wBAA+L;EAA/L,mBAA+L;EAA/L,oBAA+L;EAA/L,gBAA+L;EAA/L,oBAA+L;EAA/L,iDAA+L;EAA/L,sCAA+L;EAA/L,2DAA+L;EAA/L;AAA+L;AAI/L;EAAA,kBAAyE;EAAzE,cAAyE;EAAzE,mBAAyE;EAAzE,gBAAyE;EAAzE,yBAAyE;EAAzE,oBAAyE;EAAzE,gDAAyE;IACzE,yBAAyB;IACzB;AAFyE;AAK3E;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AAEA;;;;IAIE,yBAAyB;IACzB,2BAA2B;IAC3B,iCAAiC;EACnC;AAEA;IACE,yBAAyB;EAC3B;AAGE;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B,SAA0B;IAC1B,yBAAyB;IACzB,0BAA0B;IAC1B;AAH0B;AA6C1B;EAAA,oBAAuC;EAAvC,mBAAuC;EAAvC;AAAuC;AAIvC;EAAA,oBAA4H;EAA5H,YAA4H;EAA5H,WAA4H;EAA5H,mBAA4H;EAA5H,uBAA4H;EAA5H,qBAA4H;EAA5H,iBAA4H;EAA5H,yBAA4H;EAA5H,oBAA4H;EAA5H,mDAA4H;EAA5H,+FAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAI5H;EAAA,sBAAgD;EAAhD,4DAAgD;EAAhD,kBAAgD;EAAhD,4DAAgD;EAAhD,oBAAgD;EAAhD;AAAgD;AAIhD;EAAA,mBAAoC;EAApC;AAAoC;AAQpC;EAAA,YAAkJ;EAAlJ,WAAkJ;EAAlJ,iBAAkJ;EAAlJ,sBAAkJ;EAAlJ,4DAAkJ;EAAlJ,qBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ,oBAAkJ;EAAlJ,oBAAkJ;EAAlJ;AAAkJ;AAAlJ;EAAA,sBAAkJ;EAAlJ,4DAAkJ;EAAlJ,8BAAkJ;EAAlJ,mBAAkJ;EAAlJ,2GAAkJ;EAAlJ,yGAAkJ;EAAlJ,4FAAkJ;EAAlJ,oBAAkJ;EAAlJ;AAAkJ;AAzGtJ;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA,YAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,WAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,yDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uDAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0GAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAiInB;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sDAAsD;EACtD,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;EACxC,wDAAwD;EACxD,8DAA8D;EAC9D,+DAA+D;EAC/D,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,2CAA2C;EAC3C,yCAAyC;EACzC,kDAAkD;EAClD,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;;;;EAKE,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,8CAA8C;AAChD;;AAEA;;;;;;;;;;;;;;;;;EAiBE,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oDAAoD;AACtD;;AAEA,kBAAkB;AAClB;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,yCAAyC;IACzC,mDAAmD;EACrD;;EAEA;IACE,4CAA4C;IAC5C,oDAAoD;EACtD;;EAEA;IACE,yCAAyC;IACzC,mDAAmD;EACrD;AACF;;AAEA;;+EAE+E;AAC/E;EAGE,2BAA2B;EAC3B,0BAA0B;EAC1B,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,oCAAoC;EACpC,cAAc;EACd,6BAA6B;EAC7B,wBAAwB;EACxB,4DAA4D;EAC5D,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;EACpC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;EACpC,2DAA2D;EAC3D,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,uDAAuD;AACzD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;+EAE+E;AAC/E;EAGE,2BAA2B;EAC3B,oEAAmS;EACnS,uCAAuC;EACvC,oDAAoD;EACpD,gCAAgC;EAChC,mCAAmC;EACnC,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,4DAA4D;EAC5D,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,mDAAmD;EACnD,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,yDAAyD;AAC3D;;AAEA,4BAA4B;AAC5B;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,oEAAmS;AACrS;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;AAC5D;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;EACzB,oEAAmS;AACrS;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA,uFAAuF;;AAEvF,mEAAmE;AACnE;EACE,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;;EAEvB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;;EAErB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;;EAEvB,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;;+EAG+E;;AAE/E,oDAAoD;AACpD;;;;EAIE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE;;;;IAIE,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,0CAA0C;AAC1C;EACE;;;;IAIE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,yEAAyE;AACzE;EACE;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,aAAa;EACf;AACF;;AAEA,4EAA4E;AAC5E;EACE;;IAEE,mCAAmC;IACnC,gCAAgC;EAClC;;EAEA;;IAEE,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;EACpC;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uEAAuE;AACzE;;AAEA,qEAAqE;AACrE;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;mDACmD;AACnD;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4DAA4D;AAC9D;;AAEA,mFAAmF;AACnF;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,4EAA4E;EAC5E,8CAA8C;EAC9C,6CAA6C;EAC7C,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;AACA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;AACA;;EAEE,+CAA+C;AACjD;AACA;EACE;IACE,4BAA4B;IAC5B,uCAAuC;IACvC,mCAAmC;IACnC,yBAAyB;EAC3B;AACF;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;AACnC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA,iFAAiF,oCAAoC,EAAE;AACvH,kFAAkF,oCAAoC,EAAE;AACxH,mFAAmF,oCAAoC,EAAE;AACzH,kFAAkF,oCAAoC,EAAE;AACxH;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,6BAA6B,gBAAgB,EAAE,YAAY,EAAE;AAC/D;AACA;EACE,6BAA6B,mBAAmB,EAAE,eAAe,EAAE;AACrE;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;AACA;6DAC6D,oCAAoC,EAAE;AACnG;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE;IACE,4BAA4B;IAC5B,uCAAuC;IACvC,mCAAmC;EACrC;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAj/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,gBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kCAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,4CAk/BA;EAl/BA,qDAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,iBAk/BA;EAl/BA,iBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,iCAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,4DAk/BA;EAl/BA,oEAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,0EAk/BA;EAl/BA,8FAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,gDAk/BA;EAl/BA,6DAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,4CAk/BA;EAl/BA,qDAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6CAk/BA;EAl/BA,sDAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,+EAk/BA;EAl/BA,mGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6EAk/BA;EAl/BA,iGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,0CAk/BA;EAl/BA,uDAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,gFAk/BA;EAl/BA,oGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,iCAk/BA;EAl/BA,yCAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sHAk/BA;EAl/BA,oHAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,iBAk/BA;EAl/BA,iBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,4DAk/BA;EAl/BA,qEAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,qBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2GAk/BA;EAl/BA,yGAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,qBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,eAk/BA;EAl/BA,eAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,uBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,yBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,iBAk/BA;EAl/BA,iBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,+BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oDAk/BA;EAl/BA,yDAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,sBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,sBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,gBAk/BA;IAl/BA,uBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,gBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,gBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,eAk/BA;IAl/BA,eAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,4DAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,+DAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,4DAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,+DAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,8DAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,gCAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,6BAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,sBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,sBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,sBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,8BAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,eAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,gFAk/BA;IAl/BA,oGAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,oDAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,8BAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,gBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,uBAk/BA;IAl/BA,mDAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,gBAk/BA;IAl/BA,uBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,sBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,oBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,iBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,eAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,mBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA,kBAk/BA;IAl/BA;EAk/BA;AAAA;;AAl/BA;;EAAA;IAAA,qBAk/BA;IAl/BA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,0BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,yBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,mBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,8BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,kCAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,oBAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;;EAAA;IAAA;EAk/BA;;EAl/BA;IAAA;EAk/BA;AAAA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA;AAk/BA;;AAl/BA;EAAA,gCAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,2BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,+BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,6BAk/BA;EAl/BA;AAk/BA;;AAl/BA;EAAA,+BAk/BA;EAl/BA;AAk/BA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  .map-control-btn {\n    @apply flex items-center justify-center w-10 h-10 bg-[#ffffff] rounded-lg border border-[#d7dfea] shadow-[0_2px_8px_-2px_#2463eb1f] hover:bg-[#f0f6fe] hover:shadow-[0_4px_12px_-2px_#2463eb2e] hover:border-[#2463eb4d] transition-all duration-200 cursor-pointer backdrop-blur-sm;\n  }\n\n  .date-chip {\n    @apply md:px-5 px-3 py-2.5 rounded-lg border border-[#d7dfea] bg-[#ffffff] text-sm font-medium cursor-pointer transition-all duration-200 hover:border-[#2463eb66] hover:bg-[#f0f6fe] hover:shadow-[0_2px_8px_-2px_#2463eb26];\n  }\n\n  .date-chip-active {\n    @apply px-5 py-2.5 rounded-lg border-2 border-[#2463eb] bg-gradient-to-r from-[#2463eb1a] to-[#2463eb0d] text-[#2463eb] text-sm font-semibold cursor-pointer shadow-[0_2px_12px_-2px_#2463eb40];\n  }\n\n  .page-title {\n    @apply uppercase mb-0 font-semibold whitespace-nowrap text-gray-800 block;\n    margin-left: 0 !important;\n    margin-top: 0 !important;\n  }\n\n  .page-content-root {\n    border-left: 0 !important;\n    outline-left: 0 !important;\n  }\n\n  .page-content-root::before,\n  .page-content-root::after,\n  .page-content-root>*::before,\n  .page-content-root>*::after {\n    border-left: 0 !important;\n    box-shadow: none !important;\n    background-image: none !important;\n  }\n\n  .page-content-root>* {\n    border-left: 0 !important;\n  }\n\n  .page-stack {\n    @apply flex flex-col gap-4;\n    border-left: 0 !important;\n    padding-left: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .page-header-row {\n    @apply flex flex-wrap items-center justify-between gap-3 px-0 pt-0 pb-0;\n  }\n\n  .page-body-pad {\n    @apply px-0 py-0;\n  }\n\n  .page-tabs {\n    @apply inline-flex w-fit gap-2 overflow-hidden rounded-lg bg-white p-1 shadow-md ring-1 ring-gray-200/70 dark:bg-gray-800 dark:ring-gray-700/70;\n    margin-left: 0 !important;\n  }\n\n  .page-filter-row {\n    @apply flex flex-wrap items-end gap-3;\n    margin-left: 0 !important;\n  }\n\n  .page-action-row {\n    @apply flex flex-wrap items-center justify-end gap-3;\n  }\n\n  .list-meta-row {\n    @apply mt-3 flex flex-wrap items-center justify-between gap-2.5;\n  }\n\n  .list-meta-left {\n    @apply flex items-center gap-2 text-sm text-gray-400;\n  }\n\n  .list-meta-right {\n    @apply flex items-center gap-2 text-sm text-gray-400;\n  }\n\n  .list-meta-range {\n    @apply whitespace-nowrap;\n  }\n\n  .pager-nav {\n    @apply inline-flex items-center gap-1.5;\n  }\n\n  .pager-icon-btn {\n    @apply inline-flex h-8 w-8 items-center justify-center rounded-lg border border-transparent text-slate-400 transition-colors;\n  }\n\n  .pager-icon-btn:not(:disabled):hover {\n    @apply border-blue-100 bg-blue-50 text-[#236DB4];\n  }\n\n  .pager-icon-btn:disabled {\n    @apply cursor-not-allowed opacity-45;\n  }\n\n  .search-shell {\n    @apply flex h-[42px] w-full items-stretch;\n  }\n\n  .search-input {\n    @apply h-[42px] w-full border border-gray-300 px-3 text-sm text-gray-900 focus:border-blue-400 focus:outline-none focus:ring-1 focus:ring-blue-400;\n  }\n\n  .search-input-ltr {\n    @apply rounded-l-[10px] border-r-0 text-left;\n  }\n\n  .search-input-rtl {\n    @apply rounded-r-[10px] border-l-0 text-right;\n  }\n\n  .search-btn {\n    @apply inline-flex h-[42px] w-12 shrink-0 items-center justify-center bg-[#236DB4] text-white transition-colors hover:bg-[#1d5d9e];\n  }\n\n  .search-btn-ltr {\n    @apply rounded-r-[10px];\n  }\n\n  .search-btn-rtl {\n    @apply rounded-l-[10px];\n  }\n}\n\n.hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n:root {\n  --text-color: #333;\n  --bg-color: #ffffff;\n  --border-color: #ccc;\n  --app-font-family: 'MediumFont', 'Manrope', sans-serif;\n  --app-scrollbar-size: 8px;\n  --app-scrollbar-radius: 20px;\n  --app-scrollbar-inset: 0px;\n  --app-scrollbar-track: transparent;\n  --app-scrollbar-track-hover: transparent;\n  --app-scrollbar-thumb: linear-gradient(#b9c2e0, #b9c2e0);\n  --app-scrollbar-thumb-hover: linear-gradient(#a3add2, #a3add2);\n  --app-scrollbar-thumb-active: linear-gradient(#a3add2, #a3add2);\n  --app-scrollbar-thumb-shadow: none;\n  --app-scrollbar-glow-hover: none;\n  --app-scrollbar-glow-active: none;\n  --app-scrollbar-border-content: transparent;\n  --app-scrollbar-border-sidebar: transparent;\n  --app-scrollbar-border-modal: transparent;\n  --app-scrollbar-color-firefox: #b9c2e0 transparent;\n  --app-scrollbar-color-firefox-hover: #b9c2e0 transparent;\n}\n\nbody.light {\n  --text-color: #333;\n  --bg-color: #ffffff;\n  --border-color: #ccc;\n}\n\nbody.dark {\n  --text-color: #ccc;\n  --bg-color: #000;\n  --border-color: #444;\n}\n\nbody.high-contrast {\n  --text-color: #fff;\n  --bg-color: #000;\n  --border-color: #fff;\n}\n\nbody {\n  color: var(--text-color);\n  background-color: var(--bg-color);\n  border-color: var(--border-color);\n  font-family: var(--app-font-family);\n}\n\nhtml,\nbody,\n#root,\nbody *,\n#root * {\n  font-family: var(--app-font-family) !important;\n}\n\nbutton,\ninput,\nselect,\ntextarea,\noptgroup,\noption,\nlabel,\nlegend,\nfieldset,\ntable,\nth,\ntd,\np,\nspan,\na,\nsmall,\nstrong,\nb,\ni,\nem,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n[class*=\"select\"],\n[class*=\"Select\"],\n.react-select__menu,\n.react-select__menu *,\n.react-datepicker,\n.react-datepicker *,\n.Toastify,\n.Toastify *,\n.apexcharts-canvas,\n.apexcharts-canvas *,\n.apexcharts-tooltip,\n.apexcharts-tooltip *,\n.leaflet-container,\n.leaflet-container * {\n  font-family: var(--app-font-family) !important;\n}\n\ninput::placeholder,\ninput::-webkit-input-placeholder,\ninput::-moz-placeholder,\ninput:-ms-input-placeholder,\ntextarea::placeholder,\ntextarea::-webkit-input-placeholder,\ntextarea::-moz-placeholder,\ntextarea:-ms-input-placeholder,\n[contenteditable=\"true\"],\n[contenteditable=\"true\"] *,\n.react-select__placeholder,\n[class*=\"placeholder\"],\n[class*=\"Placeholder\"],\n.apexcharts-text,\n.apexcharts-text *,\nsvg text,\nsvg tspan {\n  font-family: var(--app-font-family) !important;\n}\n\n[dir=\"rtl\"] {\n  direction: rtl;\n}\n\nhtml[dir=\"rtl\"] body {\n  text-align: right;\n}\n\nhtml[dir=\"ltr\"] body {\n  text-align: left;\n}\n\n.scrollbar-container {\n  direction: ltr;\n}\n\nhtml[dir=\"rtl\"] .scrollbar-container {\n  direction: rtl;\n}\n\nhtml[dir=\"rtl\"] .scrollbar-container>* {\n  direction: rtl;\n}\n\n.table-scroll,\n.rtl-table-scroll {\n  direction: ltr;\n  overflow-x: auto;\n}\n\nhtml[dir=\"rtl\"] .table-scroll,\nhtml[dir=\"rtl\"] .rtl-table-scroll {\n  direction: rtl;\n}\n\nhtml[dir=\"rtl\"] .table-scroll>table,\nhtml[dir=\"rtl\"] .table-scroll table,\nhtml[dir=\"rtl\"] .rtl-table-scroll>table,\nhtml[dir=\"rtl\"] .rtl-table-scroll table {\n  direction: rtl;\n  text-align: start;\n}\n\nhtml[dir=\"rtl\"] .rtl-keep-ltr {\n  direction: ltr;\n  text-align: left;\n}\n\nhtml[dir=\"rtl\"] input,\nhtml[dir=\"rtl\"] textarea {\n  text-align: right;\n}\n\nhtml[dir=\"ltr\"] input,\nhtml[dir=\"ltr\"] textarea {\n  text-align: left;\n}\n\n.mixed-dir {\n  unicode-bidi: plaintext;\n  text-align: start;\n}\n\n.custom-zoom-control {\n  top: 60px;\n}\n\n.leaflet-left .leaflet-control {\n  margin-left: 16px !important\n}\n\n.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n  border: unset;\n  margin-right: 13px;\n}\n\n.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control .leaflet-control-zoom-in,\n.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-zoom .leaflet-bar .leaflet-control .leaflet-control-zoom-out {\n  width: 40px;\n  height: 32px;\n  border-radius: 4px;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 3px 0px #606C800D;\n}\n\n.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-layers .leaflet-control {\n  width: 40px;\n  height: 32px;\n  border-radius: 4px;\n  background: #FFFFFF;\n  box-shadow: 0px 1px 3px 0px #606C800D;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 13px;\n}\n\n.leaflet-container .leaflet-control-container .leaflet-top .leaflet-right .leaflet-control-layers .leaflet-control .leaflet-control-layers-toggle {\n  width: 20px;\n  height: 20px;\n}\n\n.zoom-container {\n  top: 50px !important\n}\n\n.leaflet-top {\n  top: 5px !important;\n}\n\n.map-with-date-panel .leaflet-top {\n  top: 92px !important;\n}\n\n.react-datepicker {\n  border: 0px !important;\n  display: inline-block !important;\n}\n\n.react-datepicker-popper .react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker-popper .react-datepicker__time-container {\n  float: right;\n}\n\n.react-datepicker__header {\n  background-color: #236DB4 !important;\n  border-top-left-radius: 10px !important;\n  border-top-right-radius: 10px !important;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  color: #FFF !important;\n}\n\n/* Backdrop ? dir ltr keeps ring/logo centered in Arabic/RTL layouts */\n.loader-backdrop {\n  position: fixed;\n  inset: 0;\n  direction: ltr;\n  background: rgba(255, 255, 255, 0.75);\n  z-index: 60;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Loader Container */\n.circular-loader {\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n/* Rotating Ring */\n.loader-ring {\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 4px solid rgba(59, 130, 246, 0.2);\n  border-top-color: #2563eb;\n  animation: spin 1.1s linear infinite;\n}\n\n/* Center Logo */\n.bluefield-logo-center {\n  position: absolute;\n  inset: 50%;\n  transform: translate(-50%, -50%);\n  width: 40px;\n  height: 40px;\n  /* animation: logoPulse 1.5s ease-in-out infinite; */\n}\n\n/* Ring Rotation */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Logo Pulse */\n@keyframes logoPulse {\n  0% {\n    transform: translate(-50%, -50%) scale(1);\n    filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.4));\n  }\n\n  50% {\n    transform: translate(-50%, -50%) scale(1.08);\n    filter: drop-shadow(0 0 12px rgba(37, 99, 235, 0.8));\n  }\n\n  100% {\n    transform: translate(-50%, -50%) scale(1);\n    filter: drop-shadow(0 0 4px rgba(37, 99, 235, 0.4));\n  }\n}\n\n/* ==========================================================================\n   Standardized Checkbox Styling (Light, Dark, High-Contrast)\n   ========================================================================== */\ninput[type=\"checkbox\"] {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  width: 1.125rem !important;\n  /* 18px */\n  height: 1.125rem !important;\n  /* 18px */\n  border: 2px solid #cbd5e1 !important;\n  /* slate-300 */\n  border-radius: 4px !important;\n  outline: none !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  position: relative !important;\n  cursor: pointer !important;\n  background-color: #ffffff !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  vertical-align: middle !important;\n}\n\ninput[type=\"checkbox\"].hidden,\ninput[type=\"checkbox\"][hidden] {\n  display: none !important;\n}\n\ninput[type=\"checkbox\"]:hover:not(:disabled) {\n  border-color: #236DB4 !important;\n  /* Brand hover */\n  box-shadow: 0 0 0 4px rgba(35, 109, 180, 0.15) !important;\n}\n\ninput[type=\"checkbox\"]:checked {\n  background-color: #236DB4 !important;\n  border-color: #236DB4 !important;\n}\n\ninput[type=\"checkbox\"]:checked::after {\n  content: \"\" !important;\n  width: 5px !important;\n  height: 9px !important;\n  border: solid white !important;\n  border-width: 0 2px 2px 0 !important;\n  transform: rotate(45deg) translate(-0.5px, -1px) !important;\n  display: block !important;\n}\n\n/* Checkbox Dark Mode Styles */\nbody.dark input[type=\"checkbox\"] {\n  background-color: #1e293b !important;\n  /* Slate 800 */\n  border-color: #475569 !important;\n  /* Slate 600 */\n}\n\nbody.dark input[type=\"checkbox\"]:hover:not(:disabled) {\n  border-color: #236DB4 !important;\n  /* Brand hover */\n  box-shadow: 0 0 0 4px rgba(35, 109, 180, 0.25) !important;\n}\n\nbody.dark input[type=\"checkbox\"]:checked {\n  background-color: #236DB4 !important;\n  border-color: #236DB4 !important;\n}\n\n/* Checkbox High Contrast Styles */\nbody.high-contrast input[type=\"checkbox\"] {\n  background-color: #000000 !important;\n  border: 2px solid #ffffff !important;\n}\n\nbody.high-contrast input[type=\"checkbox\"]:hover:not(:disabled) {\n  border-color: #ffff00 !important;\n  /* High contrast yellow */\n  box-shadow: 0 0 0 4px rgba(255, 255, 0, 0.4) !important;\n}\n\nbody.high-contrast input[type=\"checkbox\"]:checked {\n  background-color: #ffff00 !important;\n  border-color: #ffff00 !important;\n}\n\nbody.high-contrast input[type=\"checkbox\"]:checked::after {\n  border-color: #000000 !important;\n}\n\n/* Checkbox Disabled State */\ninput[type=\"checkbox\"]:disabled {\n  background-color: #f1f5f9 !important;\n  border-color: #e2e8f0 !important;\n  cursor: not-allowed !important;\n  opacity: 0.7 !important;\n}\n\nbody.dark input[type=\"checkbox\"]:disabled {\n  background-color: #334155 !important;\n  border-color: #1e293b !important;\n}\n\nbody.high-contrast input[type=\"checkbox\"]:disabled {\n  background-color: #000000 !important;\n  border-color: #888888 !important;\n  opacity: 0.5 !important;\n}\n\ninput[type=\"checkbox\"]:disabled:checked::after {\n  border-color: #94a3b8 !important;\n}\n\nbody.dark input[type=\"checkbox\"]:disabled:checked::after {\n  border-color: #475569 !important;\n}\n\n/* ==========================================================================\n   Standardized Select / Dropdown Styling (Non-multiple native selects)\n   ========================================================================== */\nselect:not([multiple]) {\n  -webkit-appearance: none !important;\n  -moz-appearance: none !important;\n  appearance: none !important;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 0.75rem center !important;\n  background-size: 1rem !important;\n  padding: 0 2.5rem 0 1rem !important;\n  height: 42px !important;\n  line-height: 42px !important;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 10px !important;\n  background-color: #ffffff !important;\n  color: #334155 !important;\n  font-size: 15px !important;\n  font-family: inherit !important;\n  font-weight: 500 !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  cursor: pointer !important;\n  box-sizing: border-box !important;\n}\n\n[dir=\"rtl\"] select:not([multiple]) {\n  background-position: left 0.75rem center !important;\n  padding: 0 1rem 0 2.5rem !important;\n}\n\nselect:not([multiple]):hover:not(:disabled) {\n  border-color: #6366f1 !important;\n}\n\nselect:not([multiple]):focus {\n  outline: none !important;\n  border-color: #6366f1 !important;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15) !important;\n}\n\n/* Select Dark Mode Styles */\nbody.dark select:not([multiple]) {\n  background-color: #1e293b !important;\n  border-color: #475569 !important;\n  color: #f1f5f9 !important;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n\nbody.dark select:not([multiple]):hover:not(:disabled) {\n  border-color: #818cf8 !important;\n}\n\nbody.dark select:not([multiple]):focus {\n  border-color: #818cf8 !important;\n  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.25) !important;\n}\n\n/* Select High Contrast Styles */\nbody.high-contrast select:not([multiple]) {\n  background-color: #000000 !important;\n  border: 2px solid #ffffff !important;\n  color: #ffffff !important;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23ffffff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\") !important;\n}\n\nbody.high-contrast select:not([multiple]):hover:not(:disabled) {\n  border-color: #ffff00 !important;\n}\n\nbody.high-contrast select:not([multiple]):focus {\n  border-color: #ffff00 !important;\n  box-shadow: 0 0 0 3px rgba(255, 255, 0, 0.4) !important;\n}\n\n/* Select Disabled State */\nselect:not([multiple]):disabled {\n  background-color: #f1f5f9 !important;\n  color: #94a3b8 !important;\n  border-color: #e2e8f0 !important;\n  cursor: not-allowed !important;\n}\n\nbody.dark select:not([multiple]):disabled {\n  background-color: #334155 !important;\n  border-color: #475569 !important;\n  color: #64748b !important;\n}\n\nbody.high-contrast select:not([multiple]):disabled {\n  background-color: #000000 !important;\n  border-color: #888888 !important;\n  color: #888888 !important;\n  opacity: 0.5 !important;\n}\n\n/* Close button visuals are centralized in src/components/common/ModalCloseButton.jsx */\n\n/* Sonner toast colors aligned with prior react-toastify defaults */\n:root {\n  --success-bg: #07bc0c;\n  --success-border: #07bc0c;\n  --success-text: #ffffff;\n\n  --error-bg: #e74c3c;\n  --error-border: #e74c3c;\n  --error-text: #ffffff;\n\n  --warning-bg: #f1c40f;\n  --warning-border: #f1c40f;\n  --warning-text: #111827;\n\n  --info-bg: #3498db;\n  --info-border: #3498db;\n  --info-text: #ffffff;\n}\n\n/* ==========================================================================\n   Batch A: Shared Responsive Header/Layout Contract\n   Safe override layer for tablet/mobile consistency across modules.\n   ========================================================================== */\n\n/* Base row behavior (desktop-first, non-breaking) */\n.page-header-row,\n.page-filter-row,\n.page-action-row,\n.list-meta-row {\n  width: 100%;\n  min-width: 0;\n  gap: 12px;\n}\n\n.page-filter-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.page-action-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.list-meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.list-meta-left,\n.list-meta-right {\n  min-width: 0;\n}\n\n/* Tablet and below: predictable stacking, cleaner wraps */\n@media (max-width: 1024px) {\n  .page-header-row,\n  .page-filter-row,\n  .page-action-row,\n  .list-meta-row {\n    gap: 10px;\n  }\n\n  .page-action-row {\n    justify-content: flex-start;\n  }\n}\n\n/* Mobile: strict vertical flow contract */\n@media (max-width: 640px) {\n  .page-header-row,\n  .page-filter-row,\n  .page-action-row,\n  .list-meta-row {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    gap: 10px;\n  }\n\n  .list-meta-left,\n  .list-meta-right {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n  }\n\n  .page-action-row > * {\n    width: 100%;\n  }\n\n  .page-action-row > *.action-icon-only,\n  .page-action-row > .action-icon-only {\n    width: auto;\n  }\n}\n\n/* Mobile-only: keep scroll behavior but hide visible scrollbar chrome. */\n@media (max-width: 640px) {\n  .mobile-hide-scrollbar {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  .mobile-hide-scrollbar::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n    display: none;\n  }\n}\n\n/* Strong mobile first-paint scrollbar suppression for known scroll shells */\n@media (max-width: 640px) {\n  .mobile-hide-scrollbar,\n  .mobile-hide-scrollbar * {\n    -ms-overflow-style: none !important;\n    scrollbar-width: none !important;\n  }\n\n  .mobile-hide-scrollbar::-webkit-scrollbar,\n  .mobile-hide-scrollbar *::-webkit-scrollbar {\n    width: 0 !important;\n    height: 0 !important;\n    display: none !important;\n    background: transparent !important;\n  }\n}\n\n/* Slider drawer keyframes and class */\n@keyframes slideInFromRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.animate-slide-in-right {\n  animation: slideInFromRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n/* Draws attention to a just-revealed per-column funnel filter icon */\n@keyframes filterIconPulse {\n  0%, 100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.35);\n  }\n}\n\n.animate-filter-pulse {\n  animation: filterIconPulse 0.45s ease-in-out 2;\n}\n\n/* Indeterminate bar for a bulk export that is queued but not started yet --\n   a 0%-wide determinate bar would read as stuck. */\n@keyframes bulkExportIndeterminate {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(300%);\n  }\n}\n\n.animate-bulk-export-indeterminate {\n  animation: bulkExportIndeterminate 1.4s ease-in-out infinite;\n}\n\n/* Regular action buttons only. Tabs, icons and text-only controls do not opt in. */\nbutton[data-button-intent=\"primary\"] {\n  --action-ring: #93c5fd;\n  --action-bg: #236db4;\n  --action-hover: #1d5a96;\n  --action-text: #ffffff;\n}\nbutton[data-button-intent=\"danger\"] {\n  --action-ring: #fca5a5;\n  --action-bg: #dc2626;\n  --action-hover: #b91c1c;\n  --action-text: #ffffff;\n}\nbutton[data-button-intent=\"warning\"] {\n  --action-ring: #fde68a;\n  --action-bg: #facc15;\n  --action-hover: #eab308;\n  --action-text: #422006;\n}\nbutton[data-button-intent=\"success\"] {\n  --action-ring: #86efac;\n  --action-bg: #15803d;\n  --action-hover: #166534;\n  --action-text: #ffffff;\n}\nbutton[data-button-intent] {\n  /* The semantic fill overrides the variant; its focus halo must do so too. */\n  --tw-ring-color: var(--action-ring) !important;\n  background-color: var(--action-bg) !important;\n  background-image: none !important;\n  color: var(--action-text) !important;\n  border-color: var(--action-bg) !important;\n}\nbutton[data-button-intent] > span:not([class*=\"bg-\"]),\nbutton[data-button-intent] svg {\n  color: inherit !important;\n}\nbutton[data-button-intent]:hover:not(:disabled):not([aria-disabled=\"true\"]) {\n  background-color: var(--action-hover) !important;\n  border-color: var(--action-hover) !important;\n}\nbutton[data-button-intent]:focus-visible {\n  outline: 2px solid var(--action-ring);\n  outline-offset: 3px;\n}\nbody.high-contrast button[data-button-intent],\n.high-contrast button[data-button-intent] {\n  border: 2px solid var(--action-text) !important;\n}\n@media (forced-colors: active) {\n  button[data-button-intent] {\n    color: ButtonText !important;\n    background-color: ButtonFace !important;\n    border-color: ButtonText !important;\n    forced-color-adjust: auto;\n  }\n}\n\n/* Shared toolbar controls: outlined Column Filters and neutral Columns. */\nbutton[data-table-control] {\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n  min-height: 40px;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid !important;\n  border-radius: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: 500;\n  background-image: none !important;\n}\nbutton[data-table-control=\"filters\"][aria-pressed=\"true\"],\nbutton[data-table-control=\"columns\"][aria-expanded=\"true\"] {\n  color: #236db4 !important;\n  background-color: #eaf3fb !important;\n  border-color: #236db4 !important;\n}\nbutton[data-table-control=\"filters\"],\nbutton[data-table-control=\"columns\"] {\n  color: #334155 !important;\n  background-color: #ffffff !important;\n  border-color: #e2e8f0 !important;\n}\nbutton[data-table-control=\"columns\"] > span[class*=\"bg-\"] {\n  color: #526783 !important;\n  background-color: #f1f5f9 !important;\n  border-radius: 9999px;\n  font-size: 11px;\n  line-height: 20px;\n  height: 20px;\n  padding: 0 6px;\n  flex-shrink: 0;\n}\nbutton[data-table-control] svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n  color: inherit;\n}\nbutton[data-table-control=\"filters\"][aria-pressed=\"true\"]:hover:not(:disabled) { background-color: #dbeafe !important; }\nbutton[data-table-control=\"filters\"][aria-pressed=\"false\"]:hover:not(:disabled) { background-color: #f8fafc !important; }\nbutton[data-table-control=\"columns\"][aria-expanded=\"false\"]:hover:not(:disabled) { background-color: #f8fafc !important; }\nbutton[data-table-control=\"columns\"][aria-expanded=\"true\"]:hover:not(:disabled) { background-color: #dbeafe !important; }\nbutton[data-table-control]:focus-visible {\n  outline: 2px solid #236db4;\n  outline-offset: 2px;\n}\n@media (min-width: 640px) {\n  button[data-table-control] { min-height: 36px; height: 36px; }\n}\n@media (max-width: 639px) {\n  button[data-table-control] { padding-inline: 8px; font-size: 12px; }\n}\nbody.dark button[data-table-control],\n.dark-mode button[data-table-control] {\n  color: #93c5fd !important;\n  background-color: #1e293b !important;\n  border-color: #64748b !important;\n}\nbody.dark button[data-table-control=\"columns\"] > span[class*=\"bg-\"],\n.dark-mode button[data-table-control=\"columns\"] > span[class*=\"bg-\"] {\n  color: #cbd5e1 !important;\n  background-color: #334155 !important;\n}\nbody.dark button[data-table-control]:hover:not(:disabled),\n.dark-mode button[data-table-control]:hover:not(:disabled) { background-color: #334155 !important; }\nbody.high-contrast button[data-table-control],\n.high-contrast button[data-table-control] {\n  color: #ffffff !important;\n  background-color: #000000 !important;\n  border-color: #ffffff !important;\n}\n@media (forced-colors: active) {\n  button[data-table-control] {\n    color: ButtonText !important;\n    background-color: ButtonFace !important;\n    border-color: ButtonText !important;\n  }\n}\n\nbutton[data-table-control=\"filters\"] > span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
